﻿/**
 * French locale messages
 * Mirrors the structure of the English source of truth
 */

import { brand } from '../config/brand';

export default {
  // Contrôles et fenêtre météo (CurrentWeather, WeatherModal, WeatherForecast)
  weather: {
    title: 'Météo actuelle',
    refresh: 'Actualiser la météo',
    updated: 'Mis à jour',
    justNow: "à l'instant",
    feelsLike: 'Ressenti',
    humidity: 'Humidité',
    wind: 'Vent',
    pressure: 'Pression',
    clouds: 'Nuages',
    visibility: 'Visibilité',
    sunrise: 'Lever du soleil',
    sunset: 'Coucher du soleil',
    hourlyForecast: 'Prévisions horaires',
    dailyForecast: 'Prévisions quotidiennes',
    forecastTitle: 'Prévisions météo',
    hourly: 'Horaire',
    daily: 'Quotidien',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    unavailable: 'Les données météo ne sont pas encore disponibles.',
    forecastUnavailable: 'Prévisions non disponibles.',
    rainPercent: '{count}% de pluie',
    noRain: 'Pas de pluie',
    configureInSettings: 'Configurez la météo dans les réglages',
    loadFailed: 'Impossible de charger les données météo',
    alertsTitle: 'Alertes météo',
    now: 'Maintenant',
    scrub: 'Parcourir les prévisions',
    sun: 'Soleil',
    moon: 'Lune',
    moonrise: 'Lever de la lune',
    moonset: 'Coucher de la lune',
    illumination: 'éclairée',
    details: 'Détails',
  },
  // Assistant d'ajout de pièces (AddRoomModal) - textes d'interface
  roomWizard: {
    addRooms: 'Ajouter des pièces',
    buildingType: 'Type de bâtiment',
    selectDefaults: 'Sélectionner les pièces par défaut pour {type}',
    selectCommonRooms: 'Sélectionner des pièces courantes',
    alreadyExists: 'Existe déjà',
    floor: 'Étage {number}',
    addCustomRoom: 'Ajouter une pièce personnalisée',
    roomName: 'Nom de la pièce',
    roomNamePlaceholder: 'p. ex. Chambre d’amis, Cave à vin',
    floorNumber: 'Numéro d’étage',
    floorNumberPlaceholder: '0, 1, 2...',
    addCustomRoomButton: 'Ajouter la pièce personnalisée à la sélection',
    areaAssignment: 'Affectation de zone (facultatif)',
    assignToArea: 'Affecter à la zone',
    noArea: 'Aucune zone',
    areaHelp: 'Toutes les pièces sélectionnées seront affectées à cette zone',
    selectedRooms: 'Pièces sélectionnées ({count})',
    clearAll: 'Tout effacer',
    cancel: 'Annuler',
    creating: 'Création...',
    createOne: 'Créer {count} pièce',
    createMany: 'Créer {count} pièces',
    searchIcons: 'Rechercher des icônes',
  },
  // Assistant d'ajout de pièces - types de bâtiment et pièces courantes
  roomPresets: {
    buildingTypes: {
      allRooms: 'Toutes les pièces',
      home: 'Résidence',
      house: 'Maison',
      office: 'Bureau',
      school: 'École',
      hotel: 'Hôtel',
      hospital: 'Hôpital',
    },
    rooms: {
      entrance_hall: 'Hall d’entrée',
      living_room: 'Salon',
      dining_room: 'Salle à manger',
      kitchen: 'Cuisine',
      pantry: 'Garde-manger',
      family_room: 'Salle familiale',
      study: 'Bureau',
      home_office: 'Bureau à domicile',
      library: 'Bibliothèque',
      master_bedroom: 'Chambre principale',
      bedroom: 'Chambre',
      bedroom_2: 'Chambre 2',
      bedroom_3: 'Chambre 3',
      bedroom_4: 'Chambre 4',
      guest_bedroom: 'Chambre d’amis',
      kids_room: 'Chambre d’enfant',
      master_bathroom: 'Salle de bains principale',
      bathroom: 'Salle de bains',
      powder_room: 'Toilettes',
      laundry: 'Buanderie',
      garage: 'Garage',
      workshop: 'Atelier',
      storage: 'Local de rangement',
      utility_room: 'Débarras',
      basement: 'Sous-sol',
      wine_cellar: 'Cave à vin',
      home_theater: 'Home cinéma',
      game_room: 'Salle de jeux',
      gym: 'Salle de sport',
      patio: 'Patio',
      balcony: 'Balcon',
      terrace: 'Terrasse',
      garden: 'Jardin',
      pool_area: 'Espace piscine',
      hallway: 'Couloir',
      attic: 'Grenier',
      reception: 'Réception',
      office: 'Bureau',
      meeting_room: 'Salle de réunion',
      conference_room: 'Salle de conférence',
      break_room: 'Salle de pause',
      restroom: 'Toilettes',
      server_room: 'Salle des serveurs',
      classroom: 'Salle de classe',
      cafeteria: 'Cafétéria',
      gymnasium: 'Gymnase',
      laboratory: 'Laboratoire',
      playground: 'Aire de jeux',
      lobby: 'Hall',
      guest_room: 'Chambre d’hôte',
      suite: 'Suite',
      restaurant: 'Restaurant',
    },
  },
  // Common UI elements - buttons, actions, generic labels
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    remove: 'Retirer',
    close: 'Fermer',
    back: 'Retour',
    confirm: 'Confirmer',
    ok: 'OK',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    error: 'Erreur',
    more: 'Plus',
    copy: 'Copier',
    all: 'Tous',
    language: 'Langue',
    password: 'Mot de passe',
  },

  // Chaînes de dialogues / boîtes de message (confirmer, alerte, toast)
  dialogs: {
    // Génériques
    areYouSure: 'Êtes-vous sûr ?',
    typeDelete: 'Saisissez « DELETE »',
    finalWarning: 'AVERTISSEMENT FINAL. Toutes les données seront supprimées. Continuer ?',
    done: 'Terminé',
    errorWithMessage: 'Erreur : {message}',
    saveFailed: "Échec de l'enregistrement des modifications",
    validationErrors: 'Veuillez corriger les erreurs suivantes :\n{errors}',
    deleteAllConversationHistory:
      "Voulez-vous vraiment supprimer tout l'historique de la conversation ? Cette action est irréversible.",
    unregisterFromCloud: "Se désinscrire du cloud ? L'accès à distance sera désactivé.",
    removeUserAccess: "Supprimer l'accès de cet utilisateur ?",
    allDevicesDeleted: 'Tous les appareils supprimés',
    allRoomsDeleted: 'Toutes les pièces supprimées',
    allIntegrationsDeleted: 'Toutes les intégrations supprimées',
    allScenesDeleted: 'Toutes les scènes supprimées',
    factoryResetInitiated: "Réinitialisation d'usine lancée.",
    // Appareil
    deviceDeleteConfirm: 'Voulez-vous vraiment supprimer « {name} » ?\n\nCette action est irréversible.',
    deviceDeleteConfirmShort: 'Voulez-vous vraiment supprimer cet appareil ?',
    deviceRemoveConfirm: 'Voulez-vous vraiment supprimer cet appareil ?',
    deviceDeleteFailed: "Échec de la suppression de l'appareil",
    devicesDeleteFailed: 'Échec de la suppression des appareils',
    deviceDeleteFailedMessage: "Échec de la suppression de l'appareil : {message}",
    deviceDuplicateFailed: "Échec de la duplication de l'appareil : {message}",
    deviceReorderFailed: "Échec de la mise à jour de l'ordre des appareils",
    deviceReinitConfirm:
      "Cela supprimera et recréera toutes les valeurs de l'appareil à partir de la définition du type d'appareil. Les valeurs créées par l'utilisateur seront conservées. Les références (adresses KNX, mappages Matter) seront perdues et devront être reconfigurées. Continuer ?",
    deviceReinitFailed: "Échec de la réinitialisation des valeurs de l'appareil",
    deviceRefsSaveFailed: "Échec de l'enregistrement des références",
    deviceRefsUpdateFailed: "Certaines références n'ont pas pu être mises à jour :\n{errors}",
    customValueDeleteConfirm: 'Supprimer la valeur personnalisée « {name} » ?',
    thumbnailUploadFailed: "Échec du téléchargement de la vignette de l'appareil : {message}",
    thumbnailRemoveFailed: "Échec de la suppression de la vignette de l'appareil : {message}",
    stateThumbnailUploadFailed: "Échec du téléchargement de l'image d'état : {message}",
    stateThumbnailRemoveFailed: "Échec de la suppression de l'image d'état : {message}",
    deviceRoomUpdateFailed: 'Échec de la mise à jour de la pièce : {message}',
    // Widget / tableau de bord
    widgetDeleteConfirm: 'Voulez-vous vraiment supprimer ce widget ?',
    widgetMissing: "Ce widget n'existe plus. Il a peut-être été supprimé. La liste des widgets va être actualisée.",
    widgetSaveFailed: "Échec de l'enregistrement : {message}",
    widgetRemoveConfirm: 'Supprimer ce widget du tableau de bord ?',
    dashboardRebuildConfirm:
      'Reconstruire « {name} » en {label} ? Les widgets existants de cette page seront remplacés.',
    dashboardDeleteConfirm: 'Supprimer « {name} » ? Cette action est irréversible.',
    dashboardGroupDeleteConfirm: 'Supprimer le groupe « {name} » ? Les pages de ce groupe seront désagroupées.',
    dashboardGroupDeleteCountConfirm: 'Supprimer le groupe « {name} » ? {count} page(s) seront désagroupées.',
    // Pièce
    roomExistsInDb: 'La pièce « {name} » existe déjà dans la base de données.',
    roomAlreadyInSelection: 'La pièce « {name} » est déjà dans votre sélection.',
    roomsCreateFailed: 'Échec de la création des pièces',
    roomUpdateFailed: 'Échec de la mise à jour de la pièce',
    // Scène
    sceneCreateFailed: 'Échec de la création de la scène',
    sceneDeleteFailed: 'Échec de la suppression de la scène',
    sceneValuesSaveFailed: "Échec de l'enregistrement des valeurs de la scène",
    sceneThumbnailUploadFailed: 'Échec du téléchargement de la vignette',
    // Automatisation
    automationCreateFailed: 'Échec de la création de la fonction',
    automationSaveFailed: "Échec de l'enregistrement de la fonction",
    automationDeleteConfirm: 'Voulez-vous vraiment supprimer « {name} » ?',
    automationDeleteFailed: 'Échec de la suppression de la fonction',
    automationDeleteFailedRetry: 'Échec de la suppression de la fonction. Veuillez réessayer.',
    // Calendrier
    calendarDeleteConfirm: 'Supprimer « {name} » et tous ses événements ?',
    calendarSaveChanges: 'Voulez-vous enregistrer vos modifications ?',
    calendarDiscardChanges: 'Abandonner les modifications non enregistrées ?',
    calendarDeleteEvent: 'Supprimer « {title} » ?',
    // Caméra / intégration
    cameraDeleteRecording: 'Supprimer cet enregistrement ? Tous les segments seront définitivement supprimés.',
    cameraDeleteRecordingEvent:
      "Supprimer cet événement d'enregistrement ? Tous les segments seront définitivement supprimés.",
    cameraDeleteConfirm: 'Supprimer la caméra « {name} » ? Tous les enregistrements seront définitivement supprimés.',
    cameraDeleteAllRecordings: 'Supprimer TOUS les enregistrements de « {name} » ? Cette action est irréversible.',
    cameraResetSettings: 'Réinitialiser tous les paramètres de streaming aux valeurs par défaut ?',
    cameraToggleFailed: "Échec de l'activation/désactivation de l'intégration : {message}",
    cameraNameSaveFailed: "Échec de l'enregistrement du nom : {message}",
    cameraSettingsSaved: 'Paramètres de la caméra enregistrés avec succès',
    cameraSettingsSaveFailed: "Échec de l'enregistrement des paramètres de la caméra : {message}",
    integrationConfigSaveFailed: "Échec de l'enregistrement de la configuration : {message}",
    knxNoInterfaces:
      'Aucune interface IP KNX trouvée sur le réseau. Assurez-vous que votre interface IP KNX est sous tension et connectée.',
    discoveryFailed: 'Échec de la découverte : {message}',
    devicesAddFailed: "Échec de l'ajout de certains appareils : {message}",
    // Galerie / images
    imageDeleteConfirm: 'Voulez-vous vraiment supprimer cette image ?',
    imageDeleteForEntity: "Supprimer l'image de type {type} de {entity} ?",
    imageReplaceForEntity: "Remplacer l'image de type {type} de {entity} ?",
    fileTooLarge: 'Le fichier est trop volumineux (50 Mo max)',
    fileDeleteConfirm: 'Supprimer « {name} » ?',
    fileDeleteFailed: 'Échec de la suppression',
    albumAddFailed: "Échec de l'ajout à l'album",
    albumRemoveFailed: "Échec du retrait de l'album",
    albumSaveFailed: "Échec de l'enregistrement de l'album",
    albumDeleteConfirm: "Supprimer l'album « {name} » ? Les photos ne seront pas supprimées.",
    albumDeleteFailed: "Échec de la suppression de l'album",
    // Médias / notes
    mediaDeleteConfirm:
      'Supprimer « {title} » de la bibliothèque multimédia ? Cela supprime également le fichier du serveur.',
    playlistDeleteConfirm: 'Supprimer cette playlist ?',
    zoneDeleteConfirm: 'Supprimer cette zone ? La lecture sera arrêtée et tous les membres seront supprimés.',
    mediaPlayerRemoveConfirm: 'Supprimer ce lecteur multimédia ?',
    coverPhotoUploadFailed: 'Échec du téléchargement de la photo de couverture',
    coverPhotoRemoveConfirm: 'Supprimer cette photo de couverture ?',
    coverPhotoRemoveFailed: 'Échec de la suppression de la photo de couverture',
    noteSaveFailed: "Échec de l'enregistrement de la note",
    noteDeleteConfirm: 'Supprimer cette note et toutes ses images ?',
    noteDeleteFailed: 'Échec de la suppression de la note',
    // Agent
    agentClearConversation: 'Effacer cette conversation ?',
    logoutConfirm: 'Voulez-vous vraiment vous déconnecter ?',
    reminderDeleteConfirm: 'Supprimer ce rappel ?',
    // Shopping
    shoppingListSaveFailed: "Échec de l'enregistrement de la liste",
    shoppingListDeleteConfirm: 'Supprimer cette liste et tous ses articles ?',
    shoppingListDeleteFailed: 'Échec de la suppression de la liste',
    shoppingItemAddFailed: "Échec de l'ajout de l'article",
    shoppingClearCheckedConfirm: 'Supprimer tous les articles cochés ?',
    shoppingClearFailed: 'Échec de la suppression des articles',
    shoppingStoreAddFailed: "Échec de l'ajout du magasin",
    shoppingStoreDeleteConfirm:
      "Supprimer ce magasin ? Les listes seront conservées mais perdront l'association au magasin.",
    shoppingStoreDeleteFailed: 'Échec de la suppression du magasin',
    // Intégration (Matter / Z-Wave / Zigbee / surveillance)
    monitoringStartFailed: 'Échec du démarrage de la surveillance : {message}',
    monitorWriteFailed: "Échec de l'écriture : {message}",
    monitorReadFailed: 'Échec de la lecture : {message}',
    mqttPropertyDeleteConfirm:
      "Supprimer cette propriété MQTT ? Les références d'appareils existantes seront supprimées.",
    modbusRegisterDeleteConfirm:
      "Supprimer ce registre Modbus ? Les références d'appareils existantes seront supprimées.",
    knxDatapointDeleteConfirm:
      "Supprimer cette adresse de groupe KNX ? Les références d'appareils existantes seront supprimées.",
    commissioningWindowFailed: "Échec de l'ouverture de la fenêtre de commissionnement",
    matterDeviceUpdateFailed: "Échec de la mise à jour de l'appareil",
    matterDeviceSaveFailed: "Échec de l'enregistrement de l'appareil",
    matterDeleteFailed: 'Échec de la suppression',
    matterError: '❌ Erreur : {message}',
    matterReinterviewConfirm: 'Ré-interroger le nœud {id} ? Cela supprimera et recréera tous les appareils de ce nœud.',
    matterDecommissioned: '✅ Nœud Matter désaffecté et supprimé avec succès',
    matterNodeDeleteError: '❌ Erreur lors de la suppression du nœud : {message}',
    matterNodeRemoveTitle: 'Supprimer le nœud Matter',
    matterNodeRemoveInspecting: 'Inspection du nœud…',
    matterNodeRemoveDecommission: 'Le contrôleur possède encore ce nœud — il sera d\'abord désaffecté, puis ses lignes seront supprimées.',
    matterNodeRemoveGhost: 'Le contrôleur ne possède pas ce nœud (son stockage a été réinitialisé ou le nœud appartient à un autre fabric). Ses lignes seront supprimées sans appeler le contrôleur.',
    matterNodeRemovePruneCounts: 'Lignes à supprimer : {endpoints} point(s) de terminaison, {clusters} cluster(s), {properties} ligne(s) d\'attribut.',
    matterNodeRemoveControllerOffline: 'Le contrôleur Matter n\'est pas démarré, impossible de choisir entre désaffectation et suppression. Démarrez d\'abord cette intégration — le hub refuse de supprimer des lignes qu\'il ne peut pas vérifier.',
    matterNodeRemoveDevicesFlag: 'Supprimer aussi les {count} appareil(s) créés depuis ce nœud (liste ci-dessous)',
    matterNodeRemoveDetach: '{count} appareil(s) d\'une autre intégration seront seulement détachés de ce nœud, pas supprimés.',
    matterNodeRemoveOtherIntegration: 'autre intégration',
    matterNodeRemoveConfirm: 'Supprimer le nœud',
    matterNodeRemoving: 'Suppression…',
    matterNodeRemoved: '✅ Nœud supprimé — {endpoints} points de terminaison, {clusters} clusters, {properties} lignes d\'attribut, {devices} appareil(s).',
    matterNodeGhostHint: 'Absent du contrôleur Matter — ce nœud ne pourra jamais être commandé.',
    matterNodeRemoveAction: 'Supprimer',
    matterDiagnosticsFailed: "Échec de l'obtention des diagnostics : {message}",
    matterFabricResetConfirm:
      '⚠️ Réinitialiser le fabric Matter ?\n\nCela va :\n- Supprimer tout le stockage et les identifiants Matter\n- Générer un nouvel ID de fabric\n- Supprimer tous les appareils commissionnés\n- Exiger le re-commissionnement de tous les appareils\n\nCette action est IRRÉVERSIBLE. Continuer ?',
    matterFabricResetSuccess:
      '✅ Réinitialisation du fabric réussie !\n\nLe contrôleur Matter va redémarrer avec un nouvel ID de fabric.\nVeuillez actualiser la page dans quelques secondes.',
    matterFabricResetFailed: '❌ Échec de la réinitialisation du fabric : {message}',
    factoryResetFailed: "Échec de la réinitialisation d'usine",
    matterDeviceRemoveFailed: "Échec de la suppression de l'appareil",
    threadSaveFailed:
      "Échec de l'enregistrement du dataset Thread. La fonction n'est peut-être pas encore implémentée sur le hub.",
    zigbeeGroupDeleteConfirm: 'Supprimer le groupe {id} ?',
    remoteSupportEndSessionFailed: 'Échec de la fin de session',
    remoteSupportSendMessageFailed: "Échec de l'envoi du message",
    zigbeeNodeRemoveConfirm: 'Supprimer le nœud {id} ?',
    zwaveNodeRemoveConfirm: 'Supprimer le nœud {id} de la base de données ?',
    zwaveNodeRenameFailed: 'Échec du renommage du nœud',
    zwaveEndpointRenameFailed: 'Échec du renommage du point de terminaison',
    wifiSaveFailed:
      "Échec de l'enregistrement des identifiants WiFi. La fonction n'est peut-être pas encore implémentée sur le hub.",
    touchPanelUnpairConfirm: "Dissocier « {name} » ? L'appareil devra être re-associé.",
    mapZoneDeleteConfirm: 'Supprimer la zone « {name} » ?',
    securityPinRemoveConfirm:
      'Supprimer le PIN des appareils secrets ? Les caméras secrètes seront accessibles sans PIN.',
    // Paramètres
    scheduleEditorComingSoon:
      "L'éditeur de planning arrive bientôt. Configurez les plannings des appareils via l'API ou la page Énergie.",
    libraryDeleteConfirm: 'Supprimer cet élément ?',
    securityModeDeleteConfirm: 'Supprimer ce mode de sécurité ? Cette action est irréversible.',
    remoteSupportRemoveUserFailed: "Échec de la suppression de l'utilisateur",
    remoteSupportUpdateAccessFailed: "Échec de la mise à jour de l'accès",
    // Utilisateur
    userSaveFailed: "Échec de l'enregistrement de l'utilisateur",
    userDeleteFailed: "Échec de la suppression de l'utilisateur : {message}",
    profilePictureRemoveConfirm: 'Voulez-vous vraiment supprimer votre photo de profil ?',
    // Serveurs
    serverRemoveFromCloud: `Supprimer « {hub} » d'${brand.agentName} Cloud ?\n\nAvertissements :\n- Les entrées d'accès partagé de ce serveur seront supprimées.\n- Le serveur ${brand.agentName} local continuera de fonctionner.\n- Pour réapparaître dans le cloud, le serveur doit se reconnecter et s'enregistrer à nouveau.\n\nCette action est irréversible.`,
    // Éditeur
    imageUrlMissing: "Le téléchargement a réussi mais aucune URL d'image n'a été renvoyée.",
    imageUploadFailed: "Échec du téléchargement de l'image",
  },

  // Authentication
  auth: {
    signIn: 'Se connecter',
    emailAddress: 'Adresse e-mail',
    passwordPlaceholder: 'Entrez votre mot de passe',
    signInToYourHub: 'Connectez-vous à votre hub',
    signInToOttoHome: `Se connecter à ${brand.platformCompact}`,
    signingIn: 'Connexion en cours...',
    invalidCredentials: 'E-mail ou mot de passe invalide',
    // No "Forgot password?" link on the sign-in form: the hub serves no
    // forgot/reset route any more (PLAN.md §4 phase 4, hub commit 51677c7),
    // so this sentence is the whole answer the form can honestly give.
    noPasswordReset:
      "Aucune r\u00e9initialisation de mot de passe : ce hub donne acc\u00e8s par invitation, pas par e-mail. Demandez \u00e0 un administrateur de vous inviter ou connectez cet appareil depuis l'application.",
    genericError: 'Une erreur est survenue. Veuillez réessayer.',
    secureSmartHome: 'Accès sécurisé à votre maison connectée',
    usernameOrEmail: "Nom d'utilisateur ou email",
    setupWizardTitle: 'Configurer votre hub',
    setupWelcome: 'Bienvenue ! Votre hub sera prêt en quelques étapes.',
    setupStepSettingsTitle: 'Paramètres système',
    setupStepSettingsDesc: 'Donnez un nom et une image à votre hub pour le reconnaître facilement.',
    setupStepCloudTitle: "S'inscrire au cloud (facultatif)",
    setupStepCloudDesc:
      "L'inscription permet l'email, les notifications push et l'accès à distance. Les services cloud sont payants.",
    setupSystemNamePlaceholder: 'ex. Ma maison',
    setupUploadImage: 'Télécharger une image',
    setupNext: 'Suivant',
    setupBack: 'Retour',
    setupFinish: 'Terminer',
    setupSkip: 'Ignorer',
    setupCloudPricing: 'Voir les tarifs',
    setupCloudRegistered: 'Inscrit au cloud',
  },

  // Navigation & Sidebar
  nav: {
    dashboard: 'Tableau de bord',
    home: 'Accueil',
    rooms: 'Pièces',
    devices: 'Appareils',
    cameras: 'Caméras',
    security: 'Sécurité',
    climate: 'Climat',
    water: 'Eau',
    appliances: 'Appareils',
    wellness: 'Bien-être',
    lights: 'Lumières',
    shades: 'Volets',
    energy: 'Énergie',
    weather: 'Météo',
    maintenance: 'Maintenance',
    apps: 'Apps',
    main: 'Principal',
    settings: 'Paramètres',
    media: 'Médias',
    intercom: 'Interphone',
    map: 'Carte',
  },

  roomsNav: {
    allRooms: 'Toutes les pièces',
    unassigned: 'Non assigné',
  },

  // Settings & System
  settings: {
    settingsUpdates: {
      hubUpdateTitle: 'Mise à jour du hub disponible',
      hubUpdateBody:
        'Une nouvelle mise à jour du hub est disponible : v{version}. Ouvrez Paramètres → Système → Mise à jour de l’appliance pour l’installer.',
      checkUpdates: 'Vérifier les mises à jour',
      checking: 'Vérification...',
      updateFailed: 'Échec de la mise à jour',
      downloadingUpdate: 'Téléchargement de la mise à jour...',
      updateReady: 'Mise à jour prête — redémarrez pour installer',
      restartInstall: 'Redémarrer et installer',
      upToDate: 'Vous êtes à jour',
      appUpdate: 'Mise à jour de l’app',
      checkFailed: 'Échec de la vérification des mises à jour',
    },
    // Addon service cards (settings/AddonServicesSection.vue): the voice
    // services and the browser & automation addon the hub runs as containers.
    addons: {
      services: 'Services',
      refresh: 'Actualiser',
      noServices: 'Aucun service disponible.',
      status: {
        running: 'En cours d’exécution',
        stopped: 'Arrêté',
        notInstalled: 'Non installé',
        installing: 'Installation en cours',
        updating: 'Mise à jour en cours',
        uninstalling: 'Désinstallation en cours',
        error: 'Erreur',
      },
      start: 'Démarrer',
      stop: 'Arrêter',
      install: 'Installer',
      logs: 'Journaux',
      logsTitle: 'Journaux (100 dernières lignes)',
      generateFromDevices: 'Générer depuis les appareils',
      generating: 'Génération...',
      availableCommands: 'Commandes disponibles',
      saveRestart: 'Enregistrer et redémarrer',
      savingRestart: 'Enregistrement et redémarrage...',
      savedRestarting: 'Enregistré — redémarrage du conteneur',
      errorPrefix: 'Erreur :',
      errorLoad: 'Échec du chargement des services',
      errorSaving: 'Erreur lors de l’enregistrement',
      errorStart: 'Échec du démarrage du service',
      errorStop: 'Échec de l’arrêt du service',
      errorInstall: 'Échec de l’installation du service',
    },
  },

  // Settings Sidebar Navigation
  settingsNav: {
    configuration: 'Configuration',
    general: 'Général',
    torikApi: 'Torik API',
    automations: 'Automatisations',
    rooms: 'Pièces',
    devices: 'Appareils',
    functions: 'Fonctions',
    modes: 'Modes',
    integrations: 'Intégrations',
    security: 'Sécurité',
    energy: 'Énergie',
    weather: 'Météo',
    climate: 'Climat',
    water: 'Eau',
    appliances: 'Appareils',
    lights: 'Éclairage',
    shades: 'Volets',
    scenes: 'Scènes',
    routines: 'Routines',
    charts: 'Graphiques',
    system: 'Système',
    users: 'Utilisateurs',
    presence: 'Suivi de présence',
    agent: 'Agent',
    demo: 'Démo',
    backup: 'Sauvegarde',
    library: 'Bibliothèque',
    dashboards: 'Tableaux de bord',
    gallery: 'Galerie',
    model: 'Modèle 3D',
    installer: 'Installateur',
    logs: 'Journaux',
    dangerZone: 'Zone dangereuse',
  },

  // Views - Nested object for all view sections
  views: {
    // Map view (views/Map.vue + components/map/MapZonePanel.vue): the hub's own
    // geofence zones and the cloud areas the cloud owns (card `t_6b57f8f2`, plan
    // docs/plans/GEOFENCING-E2E.md §2.4). `cloudRefusal*` are read indirectly
    // (`cloudAreaRefusalNotice(...).key`) — see locales/localeAudit.ts.
    map: {
      title: 'Zones de géorepérage',
      empty: 'Aucune zone pour le moment. Créez-en une avec « Ajouter une zone ».',
      radiusMeters: 'Rayon de {meters} m',
      flyTo: 'Aller à la zone',
      editZone: 'Modifier la zone',
      deleteZone: 'Supprimer la zone',
      zoneName: 'Nom de la zone',
      radiusShort: 'Rayon (m)',
      radiusMetersLabel: 'Rayon (mètres)',
      lat: 'Latitude',
      lon: 'Longitude',
      newZone: 'Nouvelle zone',
      globalZone: 'Zone globale (visible par tous les utilisateurs)',
      createZone: 'Créer la zone',
      clickHint: 'Cliquez sur la carte pour créer une nouvelle zone',
      addZone: 'Ajouter une zone',
      moveHint: 'Sélectionnez une zone, puis faites glisser sa poignée pour la déplacer',
      layerUsers: 'Utilisateurs',
      layerZones: 'Zones',
      centerOnHub: 'Centrer sur le hub',
      manageZones: 'Gérer les zones',
      hubMarker: 'Hub',
      sourceLocal: 'Sur ce serveur',
      sourceCloud: 'Zone cloud',
      cloudManaged: 'Gérée dans le cloud',
      cloudTitle: 'Zones cloud',
      cloudAdd: 'Ajouter une zone cloud',
      cloudPickHint: 'Cliquez sur la carte pour placer la nouvelle zone cloud',
      cloudLoading: 'Chargement des zones cloud…',
      cloudEmpty: 'Aucune zone cloud pour l’instant.',
      cloudRetry: 'Réessayer',
      cloudAdminOnly: 'Seul le propriétaire ou un administrateur du serveur peut modifier ses zones cloud.',
      cloudAreaName: 'Nom de la zone',
      cloudCreate: 'Créer la zone',
      cloudDeleteConfirm: 'Supprimer la zone cloud « {name} » ?',
      cloudRefusalForbidden: 'Ce compte n’est pas autorisé à modifier les zones cloud de ce serveur.',
      cloudRefusalNotMember: 'Ce compte n’a aucun rôle sur ce serveur.',
      cloudRefusalNotAdmin: 'Seul le propriétaire ou un administrateur du serveur peut modifier ses zones cloud.',
      cloudRefusalNotFound: 'Cette zone cloud n’existe plus.',
      cloudRefusalInvalidRadius: 'Le rayon doit être compris entre 50 et 5000 mètres.',
      cloudRefusalInvalidArea: 'Vérifiez le nom et la position de la zone.',
      cloudRefusalGeneric: 'Le cloud a refusé la modification.',
    },

    // Rooms view
    rooms: {
      pageTitle: 'Pièces',
      searchPlaceholder: 'Rechercher par pièce ou zone...',
      loading: 'Chargement...',
      emptyTitle: 'Aucune pièce',
      emptyDescription: 'Commencez par créer une nouvelle pièce.',
      noResultsTitle: 'Aucune pièce trouvée',
      noResultsDescription: 'Essayez un autre terme de recherche.',
      unassignedRoomsSectionTitle: 'Pièces non assignées',
      loadError: 'Échec du chargement des données',
    },

    // Scan de pièces (carte `t_90febbcf`, A2) : l’accès et son panneau
    // (`components/scan/RoomScanEntry.vue` + `RoomScanPanel.vue`). Le scan est le
    // fait du plugin natif `RoomScan` (iOS, LiDAR) ; `unsupported*` sont les
    // réponses honnêtes d’un appareil sans LiDAR (plan §7).
    // Scans 3D (carte `t_8ae1d20a`, E2) : la page de réglages qui liste les
    // scans stockés sur CE hub (`views/Settings/SettingsModel.vue`), avec
    // téléversement, remplacement, téléchargement et suppression.
    model: {
      title: 'Modèle 3D',
      subtitle: 'L’unique modèle 3D de ce hub, et les scans à partir desquels il peut être construit.',
      homeTitle: 'Modèle 3D de la maison',
      homeIntro: 'Chaque page qui montre la maison affiche ces octets — il y a un modèle par hub.',
      upload: 'Envoyer un modèle…',
      replace: 'Remplacer…',
      download: 'Télécharger',
      delete: 'Supprimer',
      active: 'Actif',
      updated: 'Mis à jour',
      loading: 'Lecture du modèle…',
      loadFailed: 'Le modèle du hub n’a pas pu être lu',
      empty: 'Aucun modèle 3D sur ce hub pour l’instant — envoyez un fichier IFC, GLB ou glTF, ou utilisez un scan 3D ci-dessous.',
      uploading: 'Envoi du modèle…',
      uploadDone: 'Le modèle a été envoyé.',
      uploadFailed: 'Le modèle n’a pas pu être envoyé',
      badFormat: 'Choisissez un fichier IFC (.ifc), GLB (.glb) ou glTF (.gltf).',
      tooLarge: 'Le fichier du modèle doit faire moins de 200 Mo.',
      downloading: 'Téléchargement du modèle…',
      downloadDone: 'Le modèle a été enregistré sous « {name} ».',
      downloadFailed: 'Le modèle n’a pas pu être téléchargé',
      deleting: 'Suppression du modèle…',
      deleteTitle: 'Supprimer le modèle 3D',
      deleteMessage:
        'Supprimer le modèle 3D du hub « {name} » ? Toutes les pages qui montrent la maison le perdent, et la vue 3D reste vide jusqu’à l’envoi d’un autre modèle.',
      deleteDone: '« {name} » a été supprimé.',
      deleteFailed: 'Le modèle n’a pas pu être supprimé',
      scanIsModel: '« {name} » est maintenant le modèle 3D du hub.',
    },
    scans: {
      title: 'Scans 3D',
      subtitle: 'Scans de pièces stockés sur ce hub. Scannez une pièce avec la caméra ou téléversez un paquet de capture depuis un téléphone.',
      scanRoom: 'Scanner une pièce',
      scanRoomHint: 'Un scan terminé est téléversé sur ce hub de lui-même.',
      uploadPackage: 'Téléverser un paquet',
      refresh: 'Actualiser',
      hubTitle: 'Sur le hub',
      deviceTitle: 'Captures sur cet appareil',
      deviceEmpty: 'Pas encore de captures sur cet appareil.',
      deviceOnHub: 'Sur le hub',
      deviceUpload: 'Téléverser',
      loading: 'Chargement des scans…',
      loadFailed: 'Impossible de charger les scans de ce hub',
      emptyTitle: 'Pas encore de scans — scannez votre première pièce',
      emptyHint:
        'Un paquet de scan est le dossier qu’écrit une capture (scan.json, model.usdz, le plan…). Téléversez-en un ici, ou scannez avec l’application.',
      modeRoom: 'Une pièce',
      modeStructure: 'Étage',
      rooms: '{count} pièce | {count} pièces',
      files: '{count} fichier | {count} fichiers',
      capturedAt: 'Capturé',
      updatedAt: 'Mis à jour',
      download: 'Télécharger',
      replace: 'Remplacer',
      delete: 'Supprimer',
      close: 'Fermer',
      retry: 'Réessayer',
      working: 'En cours…',
      reading: 'Lecture de la capture sur cet appareil…',
      uploading: 'Téléversement vers le hub…',
      replacing: 'Remplacement sur le hub…',
      downloading: 'Téléchargement depuis le hub…',
      progress: '{percent} % téléversé',
      progressUnknown: 'Le hub reçoit le paquet…',
      uploadDone: '"{name}" est sur le hub.',
      replaceDone: '"{name}" a été remplacé.',
      deleteDone: '"{name}" a été supprimé du hub.',
      downloadDone: '"{name}" enregistré — {count} fichier | "{name}" enregistré — {count} fichiers',
      deleteTitle: 'Supprimer ce scan ?',
      deleteMessage: 'Supprimer "{name}" du hub ? Ses fichiers partent avec lui et cela est irréversible.',
      validationTitle: 'Ce paquet n’a pas été envoyé',
      replaceTitle: 'Remplacer "{name}"',
      replaceHint: 'Le nouveau paquet prend la place du scan — les fichiers actuels sont supprimés.',
      replaceChooseCapture: 'Une capture sur cet appareil',
      replaceChooseFiles: 'Choisir des fichiers sur cet appareil…',
      replaceNoCaptures: 'Aucune capture sur cet appareil.',
      replaceUseCapture: 'Utiliser cette capture',
      invalid: {
        empty: 'Choisissez d’abord les fichiers d’un paquet de capture.',
        tooManyFiles: 'Un paquet contient au plus {max} fichiers.',
        fileTooLarge: '"{name}" dépasse {max} Mo.',
        packageTooLarge: 'Le paquet dépasse {max} Mo.',
        badFileName: '"{name}" ne peut pas être stocké — un nom de paquet n’a pas de chemin, pas de point initial et ne finit ni par un point ni par un espace.',
        duplicateName: '"{name}" figure deux fois dans le paquet.',
        missingUsdz: 'Le paquet a besoin de la géométrie de la pièce — un fichier .usdz.',
        badScanDoc: 'Le scan.json n’est pas un document torik.scan/v0.',
        generic: 'Le paquet ne peut pas être envoyé tel quel.',
      },
      warnings: {
        missingScanDoc: 'Pas de scan.json dans le paquet — le hub l’enregistre comme capture au niveau de la pièce.',
      },
      errors: {
        noHub: 'Ce hub est injoignable pour le moment.',
        auth: 'Le hub a refusé cette session — reconnectez-vous.',
        validation: 'Le hub a refusé le paquet.',
        readFailed: 'La capture n’a pas pu être lue sur cet appareil.',
        uploadFailed: 'Le téléversement ne s’est pas terminé.',
        downloadFailed: 'Le téléchargement ne s’est pas terminé.',
        saveFailed: 'Le fichier n’a pas pu être enregistré sur cet appareil.',
        unknown: 'Le transfert ne s’est pas terminé.',
      },
      model: {
        title: 'Scanner en 3D',
        intro: 'Scannez une pièce avec la caméra : la capture terminée est envoyée d’elle-même vers ce hub, et chaque scan peut devenir le modèle 3D de la maison sur ce hub.',
        scan3d: 'Scanner en 3D',
        empty: 'Aucun scan sur ce hub pour l’instant — commencez par « Scanner en 3D ».',
        useScan: 'Utiliser comme modèle',
        selected: 'Choisi comme modèle',
        noModel: 'Aucun fichier de modèle dans ce paquet',
        loadingFile: 'Lecture du scan depuis le hub…',
        attaching: 'Ajout du scan comme modèle 3D du hub…',
        fetchFailed: 'Le scan n’a pas pu être lu depuis le hub',
        attachFailed: 'Le scan n’a pas pu devenir le modèle 3D du hub',
      },
    },

    roomScan: {
      entryTitle: 'Scanner les pièces avec la caméra',
      entry: 'Scanner',
      title: 'Scan de pièces',
      checking: 'Vérification de la capacité de cet appareil…',
      unsupportedTitle: 'Cet appareil ne peut pas scanner de pièces',
      unsupportedLidar: 'RoomPlan nécessite un iPhone Pro ou un iPad Pro — c’est le scanner LiDAR qui mesure la pièce.',
      unsupportedPlatform: 'Le scan de pièces fonctionne dans l’appli Torik sur un iPhone Pro ou iPad Pro (LiDAR).',
      errorTitle: 'Le scan ne s’est pas terminé',
      nameLabel: 'Nom de ce scan (facultatif)',
      namePlaceholder: 'p. ex. Salon',
      startRoom: 'Scanner une pièce',
      startStructure: 'Scanner un étage entier',
      startHint: 'La vue caméra vous guide — avancez lentement et éclairez la pièce.',
      capturingRoom: 'Scan de la pièce…',
      capturingRoomFloor: 'Scan de cette pièce de l’étage…',
      capturingHint: 'Parcourez la pièce, puis appuyez sur Terminé dans la vue caméra.',
      structureRooms: 'Pièces scannées : {count}',
      structureHint: 'Chaque « Terminé » enregistre une pièce ; « Terminer » les réunit en un seul modèle.',
      scanAnother: 'Scanner une autre pièce',
      finish: 'Terminer',
      saved: 'Enregistré : {label} · {count} pièce | Enregistré : {label} · {count} pièces',
      scanFile: 'Données du modèle',
      capturesTitle: 'Sur cet appareil',
      capturesEmpty: 'Aucun scan sur cet appareil pour l’instant.',
      modeRoom: 'Une pièce',
      modeStructure: 'Étage',
      rooms: '{count} pièce | {count} pièces',
      deleteConfirm: 'Supprimer le scan « {label} » ? Tant que l’envoi n’existe pas, il n’est que sur cet appareil.',
    },

    // Devices view
    devices: {
      pageTitle: 'Appareils',
      searchPlaceholder: 'Rechercher des appareils...',
      groupByRooms: 'Pièces',
      groupByTypes: 'Types',
      loading: 'Chargement des appareils...',
      noResultsTitle: 'Aucun appareil trouvé',
      noResultsDescription: 'Essayez un autre terme de recherche.',
      emptyTitle: 'Aucun appareil',
      emptyDescription: 'Commencez par ajouter un nouvel appareil.',
      noRoomLabel: 'Aucune pièce',
      noRoomsWithDevicesTitle: 'Aucune pièce avec appareils',
      noRoomsWithDevicesDescription: 'Ajoutez des appareils et assignez-les à des pièces pour les voir organisés ici.',
      unknownType: 'Type inconnu',
      emptyTypeViewDescription: 'Ajoutez des appareils pour les voir organisés par type.',
      deleteConfirmTitle: "Supprimer l'appareil",
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer {deviceName} ?',
      cancelButton: 'Annuler',
      deleteButton: 'Supprimer',
      deletingButton: 'Suppression...',
      loadError: 'Échec du chargement des données',
    },

    // Scenes view
    scenes: {
      pageTitle: 'Scènes',
      searchPlaceholder: 'Rechercher des scènes...',
      addSceneButton: 'Ajouter une scène',
      reorderButton: 'Réorganiser',
      doneButton: 'Terminé',
      cancelButton: 'Annuler',
      deleteButton: 'Supprimer',
      loading: 'Chargement',
      emptyTitle: 'Aucune scène pour le moment',
      emptyDescription: 'Créez une scène pour commencer.',
      noResultsTitle: 'Aucune scène correspondante',
      deleteConfirmTitle: 'Supprimer la scène',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer',
      loadError: 'Échec du chargement des scènes',
      executionSuccess: 'Scène exécutée avec succès',
      executionError: 'Exécution terminée avec des erreurs',
    },

    // Routines view
    routines: {
      pageTitle: 'Routines',
      loading: 'Chargement des routines...',
      createButton: 'Créer une routine',
      editButton: 'Modifier',
      runNowButton: 'Exécuter maintenant',
      emptyTitle: 'Aucune routine pour le moment',
      emptyDescription: 'Créez votre première routine pour automatiser votre maison connectée',
      triggerCount: 'déclencheur | déclencheurs',
      conditionCount: 'condition | conditions',
      actionCount: 'action | actions',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette routine ?',
      loadError: 'Échec du chargement des routines',
      deleteError: 'Échec de la suppression de la routine',
      enabledMessage: 'Routine activée',
      disabledMessage: 'Routine désactivée',
      deletedMessage: 'Routine supprimée',
      executionStartedMessage: 'Exécution de la routine démarrée',
      executionError: "Échec de l'exécution de la routine",
    },

    // Media view
    media: {
      audioZonesTitle: 'Zones audio',
      newZoneButton: 'Nouvelle zone',
      createZoneTitle: 'Créer une zone',
      noAudioZonesTitle: 'Aucune zone audio pour le moment',
      noAudioZonesDescription: 'Créez une zone et ajoutez-y des panneaux ou des applications.',
      pausedLabel: 'En pause',
      noMediaPlayersTitle: 'Aucun lecteur multimédia',
      noMediaPlayersDescription: 'Ajoutez une intégration multimédia pour découvrir des lecteurs.',
      goToIntegrations: 'Aller aux intégrations',
      noLocalMediaMessage: 'Aucun média dans la bibliothèque pour le moment.',
    },

    // Cameras view
    cameras: {
      pageTitle: 'Caméras',
      liveTab: 'Direct',
      playbackTab: 'Lecture',
      onlineLabel: 'en ligne',
      intercomLabel: 'interphone',
      unlockSecretCamerasTitle: 'Entrez le code PIN pour voir les caméras secrètes',
      secretButton: 'Secret',
      editButton: 'Modifier',
      doneButton: 'Terminer',
      secretCameraTitle: 'Caméra secrète - cachée des invités',
      loading: 'Chargement des caméras...',
      noCamerasFoundMessage: "Aucune caméra trouvée. Ajoutez des caméras dans les paramètres d'intégration.",
      refreshSnapshotTitle: "Actualiser l'instantané",
      privacyBlurTitle: 'Flou de confidentialité',
      privacyBlurMenuTitle: 'Durée du flou',
      blur5Min: '5 minutes',
      blur15Min: '15 minutes',
      blur30Min: '30 minutes',
      blur1Hour: '1 heure',
      blur2Hours: '2 heures',
      removeBlurButton: 'Supprimer le flou',
      muteMotionNotificationsTitle: 'Couper les notifications de mouvement',
      muteMotionNotificationsMenuTitle: 'Couper les notifications de mouvement pendant',
      unmuteMotionNotificationsButton: 'Réactiver les notifications de mouvement',
      intercomBadge: 'Interphone',
      callDoorphoneTitle: 'Appeler le portier',
      editModeInstructions: 'Utilisez les flèches pour réorganiser · Cliquez sur le verrou pour marquer comme secret',
      cancelButton: 'Annuler',
      savingButton: 'Enregistrement...',
      saveOrderButton: "Enregistrer l'ordre",
      selectCamerasMessage: 'Sélectionnez les caméras ci-dessus pour démarrer la lecture',
      // Une vue en direct dont l’ICE ne se termine jamais : la réponse WHEP de la
      // caméra a été acceptée et aucune route média n’a été établie.
      // `services/mediaPath.ts` borne l’attente et nomme l’état ; les lecteurs
      // affichent cette phrase (carte t_20b35b28).
      mediaPathFailed:
        'La route média vers cette caméra n’a pas pu être établie — elle a accepté la demande, mais aucune connexion vidéo ou audio n’a abouti. Réessayez, ouvrez l’application propre à la caméra ou consultez le journal go2rtc sur le hub.',
      // Pourquoi la tentative s’est terminée, sous la phrase (carte
      // t_4d5b3263) : les trois causes demandent des suites différentes, et
      // seule la cause s’affiche — le relevé des candidats et les durées
      // restent dans la console et dans les avertissements de
      // `services/mediaPath.ts`.
      mediaPathReasonBudget:
        'Aucune route réseau vers la caméra ne s’est établie — la cause vient généralement du réseau du hub, pas de la caméra.',
      mediaPathReasonFailed: 'La route réseau vers la caméra a échoué — vérifiez le réseau du hub avant de réessayer.',
      mediaPathReasonNoCandidates: 'Cet appareil n’a pas pu préparer une connexion vers la caméra.',
    },

    // Account view
    account: {
      profileInformationTitle: 'Informations du profil',
      profilePictureLabel: 'Photo de profil',
      changePictureButton: 'Changer la photo',
      pictureFormatHint: 'PNG ou JPG (max 2 Mo)',
      fullNameLabel: 'Nom complet',
      fullNamePlaceholder: 'Entrez votre nom complet',
      emailLabel: 'Adresse e-mail',
      emailPlaceholder: "utilisateur{'@'}exemple.fr",
      phoneLabel: 'Numéro de téléphone',
      phonePlaceholder: '+33 (6) 12 34 56 78',
      bioLabel: 'Bio',
      bioPlaceholder: 'Parlez-nous de vous',
      saveProfileButton: 'Enregistrer le profil',
      savingButton: 'Enregistrement...',
      securitySettingsTitle: 'Paramètres de sécurité',
      changePasswordTitle: 'Changer le mot de passe',
      currentPasswordLabel: 'Mot de passe actuel',
      currentPasswordPlaceholder: 'Entrez le mot de passe actuel',
      newPasswordLabel: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
      confirmPasswordLabel: 'Confirmer le nouveau mot de passe',
      confirmPasswordPlaceholder: 'Confirmez le nouveau mot de passe',
      updatePasswordButton: 'Mettre à jour le mot de passe',
      updatingButton: 'Mise à jour...',
      currentDeviceLabel: 'Appareil actuel',
      thisBrowserLabel: 'Ce navigateur',
      preferencesTitle: 'Préférences',
      themeLabel: 'Thème',
      languageLabel: 'Langue',
      notificationsTitle: 'Notifications',
      savePreferencesButton: 'Enregistrer les préférences',
      memberSinceLabel: 'Membre depuis',
      lastLoginLabel: 'Dernière connexion',
      sessionTitle: 'Session',
      logoutDescription: 'Déconnectez-vous de votre session actuelle.',
      allFieldsRequired: 'Tous les champs sont requis',
      passwordMinLengthError: 'Le mot de passe doit contenir au moins 8 caractères',
      passwordsMismatchError: 'Les mots de passe ne correspondent pas',
      profileTabLabel: 'Profil',
      securityTabLabel: 'Sécurité',
      preferencesTabLabel: 'Préférences',
      infoTabLabel: 'Infos',
      themeSystemDefault: 'Système par défaut',
      themeLightOption: 'Clair',
      themeDarkOption: 'Sombre',
      languageEnglish: 'English',
      languageSpanish: 'Español',
      languageFrench: 'Français',
      languageGerman: 'Deutsch',
      languageItalian: 'Italiano',
      languageSlovenian: 'Slovenščina',
      temperatureUnitsLabel: 'Unités de température',
      celsiusOption: 'Celsius (°C)',
      fahrenheitOption: 'Fahrenheit (°F)',
      notificationGroupAlerts: 'Alertes',
      notificationGroupAlertsDetail: 'Alertes d’appareil et problèmes du hub',
      notificationGroupAutomation: 'Automatisation et avis',
      notificationGroupAutomationDetail: 'Automatisations, routines, minuteurs et rappels',
      notificationGroupMessages: 'Appels et messages',
      notificationGroupMessagesDetail: 'Appels et messages de discussion',
      notificationGroupPartly: 'Partiellement activé',
      notificationGroupsUnavailable: 'Vos réglages de notification n’ont pas pu être chargés.',
      userNotifications: {
        typeDeviceAlert: 'Alertes d’appareil',
        typeSystem: 'Problèmes du hub',
        typeAutomation: 'Automatisations',
        typeRoutine: 'Routines',
        typeInfo: 'Avis',
        typeCall: 'Appels',
        typeChat: 'Messages de discussion',
        channelPush: 'Push',
        channelInApp: 'Dans l’app',
        unavailable: 'Les réglages de notification de cette personne n’ont pas pu être chargés.',
      },
      accountInformationTitle: 'Informations du compte',
      logOutButton: 'Se déconnecter',
      loggingOutButton: 'Déconnexion en cours...',
      notSetLabel: 'Non défini',
      roleLabel: 'Rôle',
      userRoleDefault: 'Utilisateur',
      activeLabel: 'Actif',
      otherSessionsHint: 'Les autres sessions actives apparaîtront ici',
    },

    // Notifications view
    notifications: {
      title: 'Notifications',
      markAllAsRead: 'Tout marquer comme lu',
      clearAll: 'Tout effacer',
      tabAll: 'Toutes les notifications',
      tabUnread: 'Non lues',
      tabByType: 'Par type',
      loading: 'Chargement des notifications...',
      emptyState: 'Aucune notification pour le moment',
      emptyUnread: 'Tout est à jour ! Aucune notification non lue',
      noNotificationsOfType: 'Aucune notification de ce type',
      markAsUnread: 'Marquer comme non lu',
      markAsRead: 'Marquer comme lu',
      deleteButton: 'Supprimer',
      deleteAllConfirm: 'Supprimer toutes les notifications ?',
      timeJustNow: "À l'instant",
      timeMinutesAgo: 'min',
      timeHoursAgo: 'h',
      timeDaysAgo: 'j',
    },

    // Alarms view
    alarms: {
      title: 'Alarmes',
      newAlarm: 'Nouvelle alarme',
      emptyState: 'Aucune alarme pour le moment. Appuyez sur Nouvelle alarme pour commencer.',
      editAlarmTitle: "Modifier l'alarme",
      labelField: 'Libellé',
      labelPlaceholder: 'Réveil',
      timeField: 'Heure',
      repeatField: 'Répétition',
      noDaysHelp: 'Aucun jour sélectionné = alarme unique',
      snoozeField: 'Durée du rappel (minutes)',
      soundField: 'Son',
      cancel: 'Annuler',
      saveAlarm: "Enregistrer l'alarme",
      saving: 'Enregistrement...',
      confirmDelete: 'Supprimer cette alarme ?',
      daysSu: 'Di',
      daysMo: 'Lu',
      daysTu: 'Ma',
      daysWe: 'Me',
      daysTh: 'Je',
      daysFr: 'Ve',
      daysSa: 'Sa',
    },

    // People view
    people: {
      title: 'Personnes',
      searchPlaceholder: 'Rechercher des conversations...',
      loading: 'Chargement...',
      emptyPeople: 'Aucune personne trouvée',
      selfDMDescription: 'Enregistrer des messages, fichiers et liens',
      selfBadge: 'Moi',
      selfConversationHint: 'Seul vous pouvez voir ceci',
      participantsLabel: 'participants',
      audioCallTitle: 'Appel audio',
      videoCallTitle: 'Appel vidéo',
      moreOptionsTitle: "Plus d'options",
      deleteAllMessages: 'Supprimer tous les messages',
      captionPlaceholder: 'Ajouter une légende (optionnel)...',
      messagePlaceholder: 'Tapez un message...',
      someoneTyping: "Quelqu'un tape...",
    },

    // Areas view

    // Integrations view
    integrations: {
      title: 'Intégrations',
      addIntegration: 'Ajouter une intégration',
      loading: 'Chargement des intégrations...',
      emptyTitle: 'Aucune intégration',
      emptyMessage: 'Commencez par ajouter une nouvelle intégration.',
      delete: 'Supprimer',
      deleteTitle: "Supprimer l'intégration",
      confirmDeletePrefix: 'Êtes-vous sûr de vouloir supprimer',
      confirmDeleteSuffix: ' ? Cela supprimera également tous les appareils associés.',
      cancel: 'Annuler',
      deleting: 'Suppression...',
      statusDisabled: 'Désactivée',
      statusConnected: 'Connectée',
      statusDisconnected: 'Déconnectée',
      statusDemo: 'Demo',
      demoMode: 'Mode démo',
      demoModeOn: 'Démo activée',
      demoModeSaving: 'Enregistrement...',
      demoModeTooltip:
        'Mode démo : cette intégration est détachée du matériel réel et fournit des valeurs simulées. Désactivez pour vous reconnecter réellement.',
      demoModeHint: "Simuler cette intégration — aucun trafic vers l'appareil ou le bus réel.",
      demoModeActiveHint: "Fonctionne avec des valeurs simulées (pilote démo). Aucun matériel n'est contacté.",
    },

    // Agent view
    agent: {
      title: `${brand.agentName}`,
      subtitle: 'Assistant vocal et textuel',
      reset: 'Réinitialiser',
      resetTitle: "Réinitialiser si l'agent est bloqué",
      clearButton: 'Effacer',
      history: 'Historique',
      emptyTitle: 'Comment puis-je vous aider ?',
      emptyMessage: "Essayez de me demander de contrôler des appareils, vérifier l'état ou gérer votre maison",
      thinking: 'Réflexion...',
      stop: 'Arrêter',
      listeningIndicator: '🎤 Écoute... Parlez maintenant',
      placeholder: 'Tapez un message ou utilisez la voix...',
      noHistory: 'Aucun historique de conversation pour le moment',
      suggestionLights: 'Allume les lumières du salon',
      suggestionTemperature: 'Quelle est la température ?',
      suggestionCameras: 'Montre-moi les caméras',
      suggestionScene: 'Exécute la scène bonne nuit',
    },

    // Room view
    room: {
      floorLabel: 'Étage',
      addDevice: 'Ajouter un appareil',
      editRoom: 'Modifier la pièce',
      moreActions: "Plus d'actions",
      emptyTitle: 'Aucun appareil dans cette pièce',
      emptyMessage: 'Cliquez sur "Ajouter un appareil" pour en ajouter un à cette pièce.',
      scenesSection: 'Scènes',
      chartsSection: 'Graphiques',
      deleteTitle: "Supprimer l'appareil",
      confirmDeletePrefix: 'Êtes-vous sûr de vouloir supprimer',
      confirmDeleteSuffix: ' ?',
      cancel: 'Annuler',
      deleting: 'Suppression...',
      devicesSection: 'Appareils',
      editLayout: 'Modifier la mise en page',
      done: 'Terminé',
      editHint:
        "Faites glisser les appareils pour les réorganiser. Utilisez la barre d'outils de chaque appareil pour choisir son affichage.",
      dragToReorder: 'Faire glisser pour réorganiser',
      deviceSettings: "Paramètres de l'appareil",
      displayAuto: 'Auto',
      displayButton: 'Bouton',
      displayFull: 'Pleine largeur',
      displayIcon: 'Icône',
      addScene: 'Ajouter une scène',
      reorderScenes: 'Réorganiser les scènes',
      reorder: 'Réorganiser',
      dragScenesToReorder: 'Glissez les scènes pour les réorganiser',
      layout: 'Disposition',
      layoutImageAlt: 'Disposition de {room}',
      dragHandle: 'glisser',
      otherType: 'Autre',
    },

    dashboardNew: {
      actionsMenuTitle: 'Actions du tableau de bord',
      addDashboardAction: 'Ajouter un tableau de bord',
      addWidgetAction: 'Ajouter un widget',
      editDashboardAction: 'Modifier le tableau de bord',
      toggleEditModeAction: 'Basculer le mode édition',
      gridSettingsAction: 'Paramètres de la grille',
      loadingMessage: 'Chargement du tableau de bord...',
      retryButton: 'Réessayer',
      defaultDashboardName: 'Tableau de bord',
      welcomeHeading: `Bienvenue sur ${brand.platformCompact}`,
      welcomeDescription: "Commencez par créer votre premier tableau de bord à partir d'un modèle ou de zéro.",
      createDashboardButton: 'Créer un tableau de bord',
    },

    // Settings views
    settingsSystem: {
      title: 'Paramètres système',
      systemName: 'Nom du système',
      systemNamePlaceholder: `${brand.platformCompact}`,
      systemImage: 'Image du système',
      changeImage: "Changer l'image",
      uploadImage: 'Importer une image',
      removeImage: 'Supprimer',
      imageSizeLimit: 'PNG, JPG ou WebP (max 5 Mo)',
      imageTooLarge: 'Le fichier image est trop volumineux (max 10 Mo)',
      imageUploaded: 'Image importée avec succès',
      imageRemoved: 'Image supprimée avec succès',
      saveSystemSettings: 'Enregistrer les paramètres système',
      savingSystem: 'Enregistrement...',
      cloudServices: 'Services Cloud',
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      connecting: 'Connexion...',
      connectionError: 'Erreur de connexion',
      notRegistered: 'Non enregistré',
      registerCloudDescription:
        "Enregistrez votre hub auprès des services Cloud pour activer l'accès à distance et le partage.",
      cloudAccount: 'Compte Cloud',
      cloudAccountEmail: 'E-mail du compte Cloud',
      emailPlaceholder: "email{'@'}example.com",
      cloudUrl: 'URL du Cloud',
      registerWithCloud: "S'enregistrer auprès du Cloud",
      registering: 'Enregistrement...',
      reconnect: 'Reconnecter',
      reconnecting: 'Reconnexion...',
      unregister: 'Désenregistrer',
      unregistering: 'Désenregistrement...',
      sharedWith: 'Partagé avec',
      hubNotShared: "Ce hub n'est partagé avec personne d'autre.",
      removeAccess: 'Supprimer',
      viewOnly: 'Lecture seule',
      control: 'Contrôle',
      admin: 'Admin',
      emailToSharePlaceholder: "utilisateur{'@'}example.com",
      add: 'Ajouter',
      adding: 'Ajout en cours...',
      loading: 'Chargement...',
      saving: 'Enregistrement...',
      settingsSaved: 'Paramètres enregistrés avec succès',
      hubLocation: 'Localisation du hub',
      locationDescription:
        'La localisation du hub est utilisée pour les prévisions météorologiques et les calculs de lever/coucher de soleil.',
      automaticLocation: 'Automatique',
      manual: 'Manuel',
      pickLocation: 'Sélectionner la localisation sur la carte',
      latitude: 'Latitude',
      latitudePlaceholder: 'p. ex., 46.1199',
      longitude: 'Longitude',
      longitudePlaceholder: 'p. ex., 14.4992',
      elevation: 'Élévation (mètres)',
      elevationPlaceholder: 'p. ex., 500',
      location: 'Localisation',
      saveHubLocation: 'Enregistrer la localisation du hub',
      weather: 'Météo',
      weatherLocation: 'Localisation météo',
      searchCityPlaceholder: 'Entrez le nom de la ville',
      units: 'Unités',
      metric: 'Métrique (°C, m/s)',
      imperial: 'Impérial (°F, mph)',
      saveWeatherSettings: 'Enregistrer les paramètres météo',
      cityRequired: 'La ville est obligatoire',
      weatherSettingsSaved: 'Paramètres météo enregistrés',
      citySearchFailed: 'Échec de la recherche de villes',
      searchCity: 'Rechercher une ville',
      enterCityName: 'Entrez le nom de la ville',
      searching: 'Recherche en cours...',
      search: 'Rechercher',
      noCitiesFound: 'Aucune ville trouvée',
      enterCitySearch: 'Entrez au moins 2 caractères pour chercher',
      close: 'Fermer',
      checkForUpdates: 'Vérifier les mises à jour',
      checking: 'Vérification...',
      confirmInstall: 'Installer la mise à jour ? Le système va redémarrer.',
      confirmRollback: 'Revenir à la version précédente ? Le système va redémarrer.',
      installUpdate: 'Installer la mise à jour',
      installing: 'Installation...',
      systemUpdates: 'Mises à jour système',
      securityUpdateTooltip: 'Mise à jour de sécurité',
      currentVersionLabel: 'Version actuelle',
      channelLabel: 'Canal',
      lastCheckedLabel: 'Dernière vérification',
      updateAvailableLabel: 'Mise à jour disponible',
      lastUpdatedLabel: 'Dernière mise à jour',
      kernelLabel: 'noyau',
      checkingForUpdates: 'Recherche de mises à jour...',
      applianceUpdateHint:
        "Cliquez sur Rechercher les mises à jour pour vérifier les nouvelles versions de l'appliance.",
      platformdUpToDate: 'Le démon de la plateforme est à jour.',
      platformdNoUpdate: 'Aucune mise à jour du démon de la plateforme disponible.',
      platformdUpdateHint:
        'Cliquez sur Rechercher les mises à jour pour vérifier les versions du démon de la plateforme.',
      systemUpdatesDisabled: 'Les mises à jour système ne sont pas activées sur cet appareil.',
      platformdUpdate: 'Démon de la plateforme',
      platformdUpdateDescription: "Service système qui gère le réseau, le matériel et les mises à jour de l'appliance",
      installPlatformd: 'Mettre à jour le démon de la plateforme',
      confirmInstallPlatformd: 'Mettre à jour le démon de la plateforme ? Le service redémarrera brièvement.',
      platformdUpdateInProgress: 'Mise à jour du démon de la plateforme en cours — le service redémarrera à la fin.',
      licence: 'Licence',
      manageLicence: 'Gérer la licence',
      noPlan: 'Aucun forfait',
      unlimitedSeats: 'Postes illimités',
      oneSeat: '1 poste',
      seats: 'postes',
      ownerOnly: 'Propriétaire uniquement',
      accessLocalOnly: 'Accès local uniquement',
      accessRemote: 'Accès à distance',
      licensedApps: 'Applications',
      licenceNeedsRegistration: 'Enregistrez ce serveur ci-dessus pour recevoir sa licence depuis le cloud.',
      licencePending:
        'En attente de la confirmation de la licence de ce serveur par le cloud — la mise à jour se fait automatiquement en une minute.',
      licenceStale: 'Pas confirmée récemment',
      licenceStaleHint: "Le cloud n'a pas confirmé cette licence depuis un moment — vérifiez la connexion ci-dessus.",
      licenceGrantedTo: 'Attribuée à',
      licenceConfirmed: 'Dernière confirmation par le cloud',
      justNow: "à l'instant",
      minutesAgo: 'minutes',
      hourAgo: 'heure',
      hoursAgo: 'heures',
      systemIcon: 'Icône système',
      systemIconType: "Type d'icône",
      systemIconGenerated: 'Généré automatiquement',
      systemIconCustom: 'Image personnalisée',
      systemIconColor: "Couleur d'arrière-plan",
      systemIconTextColor: 'Couleur du texte',
      systemIconUpload: 'Télécharger une icône',
      systemIconPreview: 'Aperçu',
      systemIconSizeLimit: 'PNG uniquement (max 500Ko)',
      systemIconSaved: "Paramètres de l'icône système enregistrés",
      saveSystemIconSettings: "Enregistrer les paramètres de l'icône système",
      systemIconReset: 'Réinitialiser par défaut',
      systemIconResetConfirm: "Réinitialiser l'icône système par défaut ?",
      systemIconResetDone: 'Icône système réinitialisée',
      applianceUpdate: "Mise à jour de l'appliance",
      applianceUpdateDescription: `Mises à jour des logiciels du hub ${brand.agentName} et des paquets système`,
      confirmInstallSystem:
        'Installer toutes les mises à jour des paquets système ? Cela peut prendre plusieurs minutes. Le système continuera de fonctionner.',
      installAll: 'Installer toutes les mises à jour',
      rollback: 'Revenir à la version précédente',
      rollingBack: 'Retour en cours...',
      upToDate: 'Le système est à jour',
      updateInProgress: 'Mise à jour en cours — le hub redémarrera à la fin.',
      updateCheckFailed: "Échec de la vérification des mises à jour de l'appliance.",
      updateStatusInProgress: 'Une mise à jour est en cours.',
      updateInstalling: "La mise à jour est en cours d'installation — le hub redémarrera une fois terminée.",
      updateStatusInstalling: "La mise à jour est en cours d'installation — le hub redémarrera une fois terminée.",
      updateStatusNotRegistered:
        "Une inscription au cloud est requise pour que ce hub puisse rechercher des versions de l'appliance.",
      updateStatusBlocked:
        "Ce hub nécessite une mise à niveau intermédiaire avant de pouvoir installer la dernière version de l'appliance.",
      updateStatusNoRelease: "Aucune version publiée de l'appliance n'est actuellement disponible pour ce canal.",
      updateStatusUpToDate: "Ce hub utilise déjà la dernière version publiée de l'appliance.",
      updateStatusUnreachable: 'Le service de mise à jour est inaccessible.',
      updateStatusNoUpdate: "Aucune mise à jour de l'appliance n'est actuellement disponible.",
      updateStarted: "Mise à jour démarrée. Le hub redémarrera si une nouvelle version de l'appliance est installée.",
      updateStartFailed: "Échec du démarrage de la mise à jour de l'appliance.",
      rollbackInitiated: 'Retour arrière lancé. Le hub redémarrera si une image de retour arrière est disponible.',
      rollbackStartFailed: 'Échec du lancement du retour arrière.',
      systemUpdateCheckFailed: 'Échec de la vérification des mises à jour système',
      systemInstallFailed: "Échec de l'installation",
    },

    settingsUsers: {
      usersManagement: 'Personnes et appareils',
      peopleSectionTitle: 'Personnes',
      peopleSectionHint:
        'Toutes les personnes ayant un rôle sur ce hub. Une personne se connecte avec son compte Torik — aucun mot de passe local.',
      peopleEmpty: 'Personne n’est encore sur ce hub. Invitez la première personne par e-mail.',
      serverOwnerRow: 'Propriétaire de ce serveur',
      accountLinked: 'Lié à {email}',
      accountNotLinkedWithEmail: 'Aucun compte lié pour l’instant — {email}',
      accountNotLinked: 'Aucun compte lié pour l’instant',
      inviteDescription:
        'Envoyez une invitation par e-mail. La personne l’accepte connectée à son compte Torik — sans mot de passe ni code.',
      inviteRoleHint: 'Elles reçoivent le rôle {role} sur ce hub.',
      addUser: 'Ajouter un utilisateur',
      usersLoading: 'Chargement des utilisateurs...',
      done: 'Terminé',
      passwordNotAvailable:
        'Ce compte se connecte avec son compte Torik ou une invitation — il n’a pas de mot de passe local.',
      editPersonTitle: 'Modifier la personne',
      deviceListTitle: 'Appareils connectés',
      deviceLastSeen: 'Vu pour la dernière fois {date}',
    },

    settingsBackup: {
      title: 'Sauvegarde et restauration',
      automaticBackupSettings: 'Paramètres de sauvegarde automatique',
      createBackup: 'Créer une sauvegarde',
      creatingBackup: 'Création...',
      backupCreated: 'Sauvegarde créée avec succès',
      backupFailed: 'Échec de la création de la sauvegarde',
      configurationOnlyInfo:
        'Ces sauvegardes ne concernent que la configuration. Les médias, enregistrements de caméras, instantanés de caméras et historiques de valeurs enregistrées sont exclus.',
      settingsSaved: 'Paramètres de sauvegarde enregistrés',
      settingsLoadFailed: 'Impossible de charger les paramètres de sauvegarde',
      settingsSaveFailed: "Impossible d'enregistrer les paramètres de sauvegarde",
      backupBeforeUpgrade: 'Créer une sauvegarde avant la mise à jour',
      backupBeforeUpgradeDesc:
        "Crée automatiquement une sauvegarde de configuration avant l'installation d'une mise à jour logicielle.",
      weeklyEnabled: 'Activer les sauvegardes hebdomadaires',
      weeklyEnabledDesc: 'Crée une sauvegarde de configuration chaque semaine selon la planification ci-dessous.',
      weeklyDay: 'Jour de la sauvegarde',
      weeklyTime: 'Heure de la sauvegarde',
      keepBackupsCount: 'Sauvegardes conservées sur le serveur',
      keepBackupsCountHelp:
        'Les anciens fichiers de sauvegarde locaux sont supprimés automatiquement après la création de nouvelles sauvegardes.',
      destinationSettings: 'Destinations de sauvegarde',
      networkCopyEnabled: 'Copier la sauvegarde vers un emplacement réseau',
      networkCopyEnabledDesc:
        'Après la création de la sauvegarde locale du serveur, le même fichier est copié vers un dossier réseau ou un partage monté.',
      networkBackupPath: 'Chemin réseau de sauvegarde',
      networkBackupPathPlaceholder: '\\\\nas\\otto\\backups ou /mnt/backups/otto',
      networkBackupPathHelp:
        "Utilisez un chemin UNC accessible ou un dossier monté. La rétention locale du serveur ne s'applique toujours qu'au dossier de sauvegarde du serveur.",
      cloudStorageTitle: 'Stockage cloud pour les abonnés',
      cloudStorageDesc: 'Le stockage cloud pour les abonnés utilisera le même paquet de sauvegarde de configuration.',
      cloudStorageComingSoon:
        "L'envoi vers le cloud n'est pas encore actif. Il sera activé dès que le point de terminaison de sauvegarde pour les abonnés sera disponible.",
      localRetentionNote:
        'Les sauvegardes manuelles utilisent le même paquet de configuration et suivent le même paramètre de rétention locale.',
      availableBackups: 'Sauvegardes disponibles',
      noBackups: 'Aucune sauvegarde disponible',
      download: 'Télécharger',
      delete: 'Supprimer',
      deleteBackup: 'Supprimer la sauvegarde',
      confirmDeleteBackup: 'Êtes-vous sûr de vouloir supprimer cette sauvegarde ?',
      backupDeleted: 'Sauvegarde supprimée',
      restoreFromBackup: "Restaurer à partir d'une sauvegarde",
      warning:
        "Attention : La restauration à partir d'une sauvegarde remplacera toutes les données actuelles. Le système redémarrera après la restauration.",
      selectBackupFile: 'Sélectionner le fichier de sauvegarde à restaurer',
      restoringBackup: 'Restauration...',
      restoring: 'Restauration...',
      validating: 'Validation...',
      backupRestored: 'Sauvegarde restaurée avec succès',
      restoreFailed: 'Échec de la restauration de la sauvegarde',
      confirmRestore: 'Cela remplacera toutes les données actuelles. Continuer ?',
      confirmRestoreTitle: 'Confirmer la restauration',
      validationWarnings: 'Avertissements',
      backupInfo: 'Informations sur la sauvegarde',
      backupVersion: 'Version',
      backupDate: 'Date',
      incompatibleWarning:
        'Le schéma de base de données est incompatible. La restauration peut provoquer des erreurs ou une perte de données.',
      restoreInitiated: 'La restauration a été lancée. Le système redémarrera sous peu.',
      filename: 'Nom du fichier',
      created: 'Créé le',
      fileSize: 'Taille du fichier',
      downloadBackup: 'Télécharger la sauvegarde',
      selectFile: 'Sélectionner un fichier',
      deleteConfirm: 'Supprimer {filename} ?',
      downloadFailed: 'Échec du téléchargement',
      acceptedFormats: '.otto_backup, .ottohome_backup, .1hub_backup',
      restoreWizardStep1: 'Sélectionner le fichier de sauvegarde',
      restoreWizardStep2: 'Vérifier la sauvegarde',
      restoreWizardStep3: 'Options de restauration',
      restoreWizardStep4: 'Confirmer la restauration',
      restoreWizardCrossServerBanner: "Cette sauvegarde provient d'un autre serveur.",
      restoreWizardCrossServerInfo:
        'Les mots de passe utilisateur utilisent bcrypt et sont portables. Les utilisateurs existants peuvent se connecter avec leurs mots de passe. Le serveur redémarrera après la restauration - vous devrez vous reconnecter.',
      restoreWizardCreateRecoveryAdmin: 'Créer un administrateur de récupération',
      restoreWizardRecoveryUsername: "Nom d'utilisateur administrateur",
      restoreWizardRecoveryPassword: 'Mot de passe administrateur',
      restoreWizardRecoveryAdminDesc:
        "Garantit qu'au moins un compte administrateur fonctionne après une restauration entre serveurs.",
      restoreWizardPreserveHubId: "Conserver l'identité actuelle du serveur",
      restoreWizardPreserveHubIdDesc: "Empêche l'écrasement de l'identifiant unique de ce serveur (recommandé).",
      restoreWizardSummaryDb: 'La base de données sera remplacée par le contenu de la sauvegarde.',
      restoreWizardSummaryFiles: 'Les téléversements, les données Matter et les images système seront restaurés.',
      restoreWizardFinalWarning:
        'Le serveur redémarrera après la restauration. Tous les utilisateurs connectés seront déconnectés.',
      restoreWizardUserCount: '{count} comptes utilisateur dans la sauvegarde',
      restoreWizardTableCount: '{count} tables de base de données dans la sauvegarde',
      restoreWizardRestoreButton: 'Restaurer la sauvegarde',
      restoreWizardRestoring: 'Restauration de la sauvegarde...',
      restoreWizardUploading: 'Téléversement du fichier de sauvegarde...',
      restoreWizardRestoreComplete: 'Restauration terminée !',
      restoreWizardRestarting:
        'Le système redémarre. Vous serez redirigé vers la page de connexion dans {seconds} secondes...',
      restoreWizardContinue: 'Continuer',
      restoreWizardBack: 'Retour',
      restoreWizardValidating: 'Validation du fichier de sauvegarde...',
      restoreWizardValidationFailed: 'Échec de la validation du fichier de sauvegarde.',
      valuesBackupTitle: 'Sauvegarde des valeurs',
      valuesBackupDesc:
        "Sauvegarde l'historique des valeurs des appareils (journaux analogiques, journaux de compteurs, journaux de valeurs). Le fichier est téléchargé directement et n'est pas stocké sur le serveur.",
      exportValuesBackup: 'Exporter la sauvegarde des valeurs',
      exportingValues: 'Export de la sauvegarde des valeurs...',
      valuesRestoreTitle: 'Restaurer les valeurs',
      valuesRestoreDesc: "Restaurez l'historique des valeurs à partir d'un ancien fichier de sauvegarde des valeurs.",
      valuesRestoreInfo:
        "Seules les lignes dont les valeurs d'appareil correspondent sont importées. Les valeurs des appareils inexistants sont ignorées. Il s'agit d'une fusion - les données existantes sont conservées.",
      selectValuesBackup: 'Sélectionner le fichier de sauvegarde des valeurs',
      importingValues: 'Import de la sauvegarde des valeurs...',
      valuesRestoreResult: 'Valeurs restaurées : {inserted} insérées, {skipped} ignorées',
      valuesRestoreFailed: 'Échec de la restauration de la sauvegarde des valeurs',
    },

    settingsAgent: {
      configuration: 'Configuration',
      voice: 'Voix',
      enableAgent: "Activer l'agent",
      enableAgentDesc:
        "Activez l'agent IA pour vous aider avec les commandes vocales et l'automatisation de la maison intelligente.",
      wakeWord: "Mot d'activation",
      wakeWordDesc: `Choisissez la commande vocale qui active l'agent (par exemple, "Hey ${brand.agentName}", "OK Nabu").`,
      voiceDesc: "Sélectionnez votre voix préférée pour les réponses de l'agent.",
      autoListen: 'Écoute automatique',
      autoListenDesc:
        "Démarrez automatiquement l'écoute après la réponse de l'agent, permettant une conversation continue.",
      confirmActions: 'Confirmer les actions',
      confirmActionsDesc: "Demander une confirmation de l'utilisateur avant d'exécuter les commandes automatisées.",
      settings: 'Paramètres',
      saving: 'Enregistrement...',
      voiceServices: 'Services vocaux',
      browserServices: 'Navigateur et automatisation',
    },

    settingsDevices: {
      searchDevices: 'Rechercher des appareils...',
    },

    settingsDangerZone: {
      dangerZone: 'Zone dangereuse',
      deleteAllRooms: 'Supprimer toutes les pièces',
      deleteAllRoomsDesc:
        'Supprime définitivement toutes les pièces et leurs configurations. Cette action ne peut pas être annulée.',
      deleteAllDevices: 'Supprimer tous les appareils',
      deleteAllDevicesDesc:
        'Supprime définitivement tous les appareils et leurs paramètres. Cette action ne peut pas être annulée.',
      deleteAllIntegrations: 'Supprimer toutes les intégrations',
      deleteAllIntegrationsDesc:
        'Déconnecte et supprime toutes les intégrations. Cette action ne peut pas être annulée.',
      deleteAllScenes: 'Supprimer toutes les scènes',
      deleteAllScenesDesc:
        'Supprime définitivement toutes les scènes et automatisations. Cette action ne peut pas être annulée.',
      factoryReset: "Réinitialisation d'usine",
      warning: 'Attention : cette action ne peut pas être annulée.',
      resetting: 'Réinitialisation...',
    },

    settingsLogs: {
      title: 'Journaux système',
      logRetention: 'Nettoyage des journaux',
      logRetentionDescription:
        'Supprimer automatiquement les anciens enregistrements des tables de journaux. Définissez combien de jours conserver les données.',
      valueLogsRetention: 'Journaux de valeurs',
      scriptExecutionLogRetention: "Journal d'exécution des scripts",
      presenceEventsRetention: 'Événements de présence',
      intercomCallsRetention: 'Appels intercom',
      notificationsRetention: 'Notifications',
      eventsRetention: 'Événements système',
      sceneExecutionsRetention: 'Exécutions de scènes',
      messagesRetention: 'Messages',
      days: 'jours',
      saveLogRetention: 'Enregistrer les paramètres de nettoyage',
      cleanNow: 'Nettoyer maintenant',
      cleaning: 'Nettoyage...',
      cleanNowConfirm: 'Êtes-vous sûr ? Les anciens enregistrements seront définitivement supprimés.',
      logRetentionSaved: 'Paramètres de nettoyage des journaux enregistrés',
      logCleanupDone: 'Nettoyage terminé : {count} enregistrements supprimés',
      saving: 'Enregistrement...',
    },

    settingsPlatform: {
      title: 'Plateforme',
      storage: 'Stockage',
      dockerEngine: 'Moteur',
      dockerCli: 'CLI',
      hardwareDescription: 'Profil matériel de la plateforme et état GPIO',
      testHardware: 'Tester le matériel',
      hardwareTest: 'Test du matériel',
      hardwareTestDescription: 'Contrôlez la LED système et simulez des pressions de bouton pour les tests.',
      ledCurrent: 'État actuel de la LED',
      cancel: 'Annuler',
      close: 'Fermer',
      timeConfiguration: "Configuration de l'heure",
      timezone: 'Fuseau horaire',
      loadingTimezones: 'Chargement des fuseaux horaires...',
      ntpServers: 'Serveurs NTP',
      ntpPlaceholder: 'ntp.example.com, pool.ntp.org',
      ntpDescription: 'Liste séparée par des virgules de serveurs NTP. Laissez vide pour les serveurs par défaut.',
      saveTimeSettings: "Enregistrer les paramètres d'heure",
      timeSettingsSaved: "Paramètres d'heure enregistrés avec succès",
      refresh: 'Actualiser',
      refreshing: 'Actualisation...',
      daemon: 'Daemon de plateforme',
      noUrlConfigured: 'Aucune URL configurée',
      version: 'Version',
      uptime: 'Temps de fonctionnement',
      profile: 'Profil',
      mode: 'Mode',
      mock: 'Simulation',
      hardwareMode: 'Matériel',
      hardware: 'Matériel',
      gpioConfigured: 'GPIO configuré',
      mockGpio: 'GPIO simulé',
      systemLed: 'LED système',
      fan: 'Ventilateur',
      capabilities: 'Capacités',
      ledState: 'État LED',
      apply: 'Appliquer',
      applying: 'Application...',
      buttonPress: 'Appui bouton',
      buttonShort: 'Court',
      buttonMedium: 'Moyen',
      buttonLong: 'Long',
      buttonVeryLong: 'Très long',
      simulate: 'Simuler',
      simulating: 'Simulation...',
      host: 'Host',
      hostname: "Nom d'hôte",
      runtime: "Environnement d'exécution",
      systemUptime: 'Temps actif du système',
      memory: 'Mémoire',
      temperature: 'Température',
      loadAverage: 'Charge moyenne',
      dockerServices: 'Services Docker',
      available: 'Disponible',
      unavailable: 'Indisponible',
      restart: 'Redémarrer',
      restarting: 'Redémarrage...',
      noContainersReported: 'Aucun conteneur signalé.',
      power: 'Alimentation',
      enabled: 'Activé',
      disabled: 'Désactivé',
      platform: 'Plateforme',
      command: 'Commande',
      requesting: 'Envoi de la demande...',
      reboot: 'Redémarrer',
      shutdown: 'Arrêter',
      events: 'Événements',
      noEventsReported: 'Aucun événement signalé.',
      loadingStatus: 'Chargement du statut',
      notConfigured: 'Non configuré',
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      none: 'Aucun',
      na: 'n/d',
      noStatus: 'Aucun statut',
      of: 'sur',
      running: 'en cours',
      unknown: 'Inconnu',
      ledBooting: 'Démarrage',
      ledHealthy: 'Opérationnel',
      ledDegraded: 'Dégradé',
      ledOffline: 'Offline',
      ledUpdating: 'Mise à jour',
      ledError: 'Erreur',
      ledFactoryResetPending: 'Réinitialisation usine en attente',
      ledUnknown: 'Inconnu',
      confirmRestart: 'Redémarrer {name} ?',
      confirmReboot: "Redémarrer l'hôte ?",
      confirmShutdown: "Arrêter l'hôte ?",
      se: {
        mode: 'Mode',
        type: 'Type',
        notFound: 'Non trouvé',
        error: 'Erreur',
        title: 'Élément sécurisé',
        description: 'Coprocesseur cryptographique matériel pour la certification Matter',
        serial: 'Numéro de série',
        i2C: 'Bus I²C',
        provisioned: 'Provisionné',
        present: 'Présent',
        yes: '✓ Oui',
        no: 'Pas encore',
      },
      monitoring: {
        title: 'Surveillance système',
        description:
          "Configurez des alertes pour les seuils d'utilisation du disque. Des notifications sont envoyées aux administrateurs lorsque les limites sont atteintes.",
        alerts: 'Alertes',
        diskWarning: "Seuil d'avertissement du disque",
        diskCritical: 'Seuil critique du disque',
        save: 'Enregistrer les paramètres de surveillance',
        diskUsage: 'Disque',
        offlineNotice:
          'Le démon de la plateforme est hors ligne — les seuils peuvent être des valeurs locales de secours et ne peuvent pas être enregistrés.',
      },
      network: {
        title: 'Réseau',
        description: "Gestion des interfaces réseau, du WiFi et du nom d'hôte",
        hostname: "Nom d'hôte",
        gateway: 'Passerelle par défaut',
        gatewayShort: 'GW',
        dns: 'Serveurs DNS',
        backend: 'Backend',
        default: 'Par défaut',
        noInterfaces: 'Aucune interface signalée.',
        connectSsid: 'WiFi SSID',
        ssidPlaceholder: 'Scannez ou saisissez un SSID',
        password: 'Mot de passe',
        passwordPlaceholder: 'Mot de passe WiFi',
        scan: 'Scanner',
        scanning: 'Analyse...',
        connect: 'Connecter',
        connecting: 'Connexion...',
        saveHostname: "Enregistrer le nom d'hôte",
        resetDhcp: 'Réinitialiser le filaire en DHCP',
        resetting: 'Réinitialisation...',
        error: 'Erreur',
        confirmHostname:
          "Changer le nom d'hôte en {hostname} ? Cela peut affecter l'accès mDNS (par ex. {hostname}.local).",
        confirmResetDhcp: "Réinitialiser l'interface filaire en DHCP ? Cela peut changer l'adresse IP.",
        configure: 'Configurer',
        static: 'IP statique',
        dhcp: 'DHCP',
        methodLabel: 'Méthode',
        ipConfig: 'Configuration IP',
        ipAddress: 'Adresse IP',
        prefix: 'Préfixe',
        dnsDescription: 'Serveurs DNS séparés par des virgules.',
        dhcpDescription:
          "L'interface obtiendra automatiquement son adresse IP, sa passerelle et son DNS auprès du réseau.",
        confirmStatic: 'Définir {iface} sur une IP statique ({address}) ? La connexion sera brièvement interrompue.',
        confirmDhcp: 'Définir {iface} en DHCP ? La connexion sera brièvement interrompue.',
        wifi: 'WiFi',
        wired: 'Filaire',
      },
      saving: 'Enregistrement...',
    },

    integrationCameras: {
      loadingState: 'Chargement des caméras...',
      camerasTab: 'Caméras',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      statusConnected: 'Connecté',
      statusReady: 'Prêt',
      nvr: {
        serverSection: 'Partager ce hub (serveur NVR)',
        serverSectionHint: `D'autres hubs ${brand.platformCompact} peuvent se connecter ici et regarder les caméras que vous leur assignez.`,
        connectionInfo: 'Infos de connexion',
        hubUrl: "URL du hub (utilisée comme URL maître sur l'autre hub)",
        newClient: 'Nouveau client',
        clientName: 'Nom du client',
        createClient: 'Créer',
        enabled: 'Activé',
        disabled: 'Désactivé',
        clientsTitle: 'Clients (autres hubs)',
        noClients: "Aucun client pour l'instant — créez-en un pour obtenir un jeton à usage unique.",
        tokenTitle: 'Jeton client à usage unique',
        tokenHint:
          "Collez ce jeton dans l'autre hub lors de l'ajout d'une source NVR. Il n'est affiché qu'une seule fois.",
        close: 'Fermer',
        assignedCameras: 'Caméras assignées',
        saveAssignment: 'Enregistrer les caméras',
        lastSeen: 'Vu pour la dernière fois',
        neverSeen: 'Jamais connecté',
        deleteClient: 'Supprimer',
        remoteClient: 'Distant',
        sourceSection: 'Autres hubs (sources NVR)',
        sourceSectionHint:
          "Ajoutez un hub qui partage des caméras avec vous, puis importez ses caméras. Les caméras importées sont des clients légers — l'enregistrement se fait sur le hub source.",
        addSource: 'Ajouter une source',
        sourceName: 'Nom',
        masterUrl: 'URL du hub',
        masterUrlHint:
          "URL de base de l'autre hub, par ex. https://my-hub. Son API est servie sous /api — https://my-hub et https://my-hub/api sont acceptés.",
        token: 'Jeton',
        test: 'Tester',
        testOk: 'Accessible',
        testFail: 'Échec',
        showCameras: 'Afficher les caméras',
        importSelected: 'Importer la sélection',
        noRemoteCameras: 'Aucune caméra ne vous est encore assignée sur ce hub.',
        remoteCamerasTitle: 'Caméras disponibles sur le hub source',
        importedTitle: 'Importées sur ce hub',
        noImported: "Aucune caméra importée pour l'instant.",
        remove: 'Supprimer',
        removeAll: 'Tout supprimer',
        sync: 'Synchroniser',
        adminRequired: 'Seuls les administrateurs peuvent gérer le partage NVR.',
        error: 'Échec du chargement des paramètres de partage NVR.',
      },
      nvrTab: 'NVR',
    },

    integrationDatapoints: {
      backButton: 'Retour aux intégrations',
      pageTitle: 'Points de données',
      loadingState: 'Chargement des points de données...',
      statusConnected: 'Connecté',
      statusDisconnected: 'Déconnecté',
      errorMessage: 'Échec du chargement des points de données',
    },

    integrationHomeAssistant: {
      entitiesTab: 'Entités',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      loadingState: 'Chargement des données Home Assistant...',
      errorMessage: 'Échec de la connexion à Home Assistant',
    },
    settingsTorikApi: {
      cancel: 'Annuler',
      title: 'Torik API',
      subtitle: 'API REST + WebSocket compatible Home Assistant pour outils externes et liaisons hub à hub.',
      refresh: 'Actualiser',
      running: "Serveur API en cours d'exécution",
      stopped: 'Serveur API arrêté',
      port: 'Port',
      clients: 'Clients connectés',
      tokenCount: 'Jetons actifs',
      enabled: 'Activé',
      enabledToast: 'API Torik activée',
      disabledToast: 'API Torik désactivée',
      endpoints: 'Points de terminaison',
      authHint: `Authentifiez-vous avec "Authorization: Bearer ***" (WebSocket: {'{'}"type":"auth","access_token":"<token>"{'}'}).`,
      tokensTitle: "Jetons d'accès",
      tokensHint: 'Jetons porteurs de longue durée. Créez-en un ici et collez-le dans le hub de liaison.',
      newToken: 'Nouveau jeton',
      noTokens: "Aucun jeton d'API pour l'instant.",
      lastUsed: 'dernière utilisation',
      never: 'jamais',
      active: 'Actif',
      disabled: 'Désactivé',
      delete: 'Supprimer',
      deleteConfirm: "Supprimer ce jeton ? Les clients qui l'utilisent perdent immédiatement l'accès.",
      deleted: 'Jeton supprimé',
      createTitle: "Créer un jeton d'API",
      tokenCreatedTitle: 'Jeton créé',
      tokenName: 'Nom du jeton',
      tokenNamePlaceholder: 'par ex. hub secondaire, Node-RED',
      creating: 'Création...',
      create: 'Créer',
      copyWarning: "Copiez ce jeton maintenant — il n'est affiché qu'une seule fois.",
      copy: 'Copier',
      copied: 'Jeton copié',
      copyFailed: 'Échec de la copie',
      done: 'Terminé',
    },

    integrationKNX: {
      statusDisabled: 'Désactivé',
      statusConnected: 'Connecté',
      statusDisconnected: 'Déconnecté',
      deleteAllDevicesButton: 'Supprimer tous les appareils',
      loadingState: 'Chargement des données KNX...',
      settingsTab: 'Paramètres',
      datapointsTab: 'Points de données',
      devicesTab: 'Appareils',
      groupMonitorTab: 'Moniteur de groupe',
      logsTab: 'Journaux',
      deleteModalTitle: 'Supprimer tous les appareils KNX',
      deleteConfirmMessage:
        'Êtes-vous sûr de vouloir supprimer tous les appareils KNX ? Cette action ne peut pas être annulée.',
      deleteConfirmLabel: 'Pour confirmer, tapez "DELETE" ci-dessous :',
      deleteConfirmPlaceholder: 'Tapez DELETE pour confirmer',
      cancelButton: 'Annuler',
      deleteConfirmButton: 'Supprimer tous les appareils',
      deletingState: 'Suppression des appareils...',
      errorMessage: 'Échec du traitement de la requête KNX',
    },

    remoteSupport: {
      selectIntegration: "Sélectionner l'intégration KNX",
      selectIntegrationPlaceholder: 'Choisir une intégration KNX...',
      knxRemoteSupport: 'Assistance KNX à distance',
      tpuartTitle: 'Pilote TP-UART requis',
      tpuartDesc:
        "Le partage d'interface KNX via le pilote TP-UART sera disponible lorsque le démon de plateforme le prendra en charge.",
      remoteUsers: "Utilisateurs d'assistance",
      remoteUsersDesc:
        "Gérez les utilisateurs pouvant fournir une assistance à distance. Ajoutez des utilisateurs par e-mail et configurez les limites de temps d'accès.",
      addUserByEmail: 'Ajouter un utilisateur par e-mail',
      emailPlaceholder: "utilisateur{'@'}exemple.fr",
      addUser: 'Ajouter',
      adding: 'Ajout...',
      remove: 'Supprimer',
      removing: 'Suppression...',
      installerRole: 'Installateur',
      noEmail: "Pas d'e-mail",
      noRemoteUsers: "Aucun utilisateur d'assistance ajouté.",
      editAccess: 'Modifier',
      day: 'Jour',
      days: 'Jours',
      daysAccess: "jours d'accès",
      perSession: 'par session',
      unlimited: 'Illimité',
      unlimitedAccess: 'Accès illimité',
      confirmRemoveUser:
        "Supprimer {name} de l'assistance à distance ? Son compte sera reconverti en utilisateur normal.",
      accessDaysPrompt: "Durée d'accès (jours, 0 = illimité) :",
      accessHoursPrompt: 'Heures max par session :',
      newSession: "Nouvelle session d'assistance",
      selectUser: 'Sélectionner un utilisateur',
      selectUserPlaceholder: 'Choisir un utilisateur...',
      timeWindow: 'Durée de la session',
      createSession: 'Créer une session',
      creating: 'Création...',
      endSession: 'Terminer la session',
      ending: 'Terminaison...',
      activeSessions: 'Sessions actives',
      installerLabel: 'Installateur',
      timeRemaining: 'Temps restant',
      expired: 'Expiré',
      justNow: "à l'instant",
      ago: '',
      hour: 'Heure',
      hours: 'Heures',
      minutes: 'Minutes',
      send: 'Envoyer',
      messagePlaceholder: 'Saisir un message...',
      noMessages: 'Pas encore de messages.',
      issueReport: 'Rapport de problème / Chat',
      issueReportDesc: "Envoyez un message à l'utilisateur d'assistance concernant le problème en cours.",
      viewChat: 'Chat',
      cannotAddSelf:
        "Vous ne pouvez pas vous ajouter vous-même. Cela vous bloquerait l'accès à votre compte administrateur.",
    },

    integrationMatter: {
      loadingState: 'Chargement des données Matter...',
      settingsTab: 'Paramètres',
      nodesTab: 'Nœuds',
      devicesTab: 'Appareils',
      logsTab: 'Journaux',
      errorMessage: 'Échec de la connexion au réseau Matter',
    },

    integrationMatterBridge: {
      brideDeviceCount: 'Appareils pontés',
      loadingState: 'Chargement des données Matter Bridge...',
      bridgedDevicesTab: 'Appareils pontés',
      commissioningTab: 'Mise en service',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      errorMessage: 'Échec de la connexion à Matter Bridge',
    },

    integrationComputers: {
      subtitle: `Ordinateurs exécutant l'agent ${brand.agentName}, appairés à ce hub.`,
      integrationLabel: `Ordinateurs ${brand.platformCompact}`,
      refreshAction: 'Actualiser',
      addComputerAction: 'Ajouter un ordinateur',
      totalLabel: 'Ordinateurs',
      onlineLabel: 'En ligne',
      offlineLabel: 'Hors ligne',
      onlineState: 'En ligne',
      offlineState: 'Hors ligne',
      connectedState: 'Connecté',
      noComputersState: 'Activé, aucun ordinateur',
      disabledState: 'Désactivé',
      unknownState: 'Inconnu',
      loadingState: 'Chargement des ordinateurs…',
      emptyTitle: "Aucun ordinateur pour l'instant",
      emptyMessage: `Installez l'agent ${brand.agentName} sur un ordinateur et appairez-le à ce hub pour le contrôler depuis ${brand.platformName}.`,
      hostLabel: 'Hôte',
      platformLabel: 'Plateforme',
      agentVersionLabel: 'Agent',
      lastSeenLabel: 'Dernière vue',
      neverSeen: 'jamais',
      memoryLabel: 'Mémoire',
      diskLabel: 'Disque',
      tempLabel: 'Température CPU',
      uptimeLabel: 'Durée de fonctionnement',
      rebootAction: 'Redémarrer',
      sleepAction: 'Veille',
      shutdownAction: 'Éteindre',
      wakeAction: 'Réveiller',
      wakeSendAction: 'Envoyer le paquet de réveil',
      wakeHint:
        "Le hub envoie le paquet de réveil depuis son propre réseau (WOL doit être activé dans le BIOS de l'ordinateur).",
      removeAction: 'Supprimer',
      refreshNodeAction: "Actualiser l'état",
      macPlaceholder: 'AA:BB:CC:DD:EE:FF',
      loadError: 'Impossible de charger les ordinateurs',
      refreshFailed: "Échec de l'actualisation",
      powerSent: "Commande d'alimentation envoyée à",
      powerFailed: "Échec de la commande d'alimentation",
      wakeSent: 'Paquet de réveil envoyé',
      wakeFailed: 'Échec de Wake-on-LAN',
      removeConfirmTitle: "Supprimer l'ordinateur ?",
      removeConfirmMessage: "Cela dissocie l'ordinateur de ce hub et supprime son appareil.",
      removed: 'Ordinateur supprimé',
      removeFailed: 'Échec de la suppression',
      addDialogTitle: 'Ajouter un ordinateur',
      addDialogSubtitle: `Générez un code d'appairage, puis installez l'agent ${brand.agentName} sur l'ordinateur avec ce code. Le code expire après 15 minutes.`,
      nodeNamePlaceholder: 'p. ex. PC du bureau',
      generateTokenAction: "Générer un code d'appairage",
      copyTokenAction: 'Copier',
      pairingCodeLabel: "Code d'appairage",
      installCommandTitle: "Sur l'ordinateur, exécutez :",
      doneAction: 'Terminé',
      copied: "Code d'appairage copié",
      copyFailed: 'Échec de la copie',
      pairingFailed: "Échec de la génération du code d'appairage",
      macLabel: 'MAC',
      hubAddressLabel: 'Adresse du hub',
      hubAddressHint:
        "L'adresse que les ordinateurs utiliseront pour joindre ce hub. La liste affiche les adresses réseau de ce hub — choisissez celle que l'ordinateur peut atteindre (par ex. le même réseau), ou saisissez une adresse personnalisée. En production (https), l'adresse du hub est présélectionnée.",
      commandCopied: 'Commande copiée',
      computersTab: 'Ordinateurs',
      devicesTab: 'Appareils',
      customHubAddressAction: 'Adresse personnalisée...',
      customHubAddressPlaceholder: 'http://192.168.1.72',
      selectHubAddressHint: "Choisissez une adresse de hub ci-dessus pour voir les commandes d'installation.",
    },
    integrationTouchPanels: {
      integrationName: 'Panneaux tactiles',
      statusDisabled: 'Désactivé',
      statusConnected: 'Connecté',
      statusReady: 'Prêt',
      loadingState: "Chargement de l'intégration des panneaux tactiles...",
      panelsTab: 'Panneaux',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      refreshAction: 'Actualiser',
      panelsAction: 'Panneaux',
      settingsAction: 'Paramètres',
      logsAction: 'Journaux',
      totalPanelsLabel: 'Panneaux enregistrés',
      onlinePanelsLabel: 'En ligne',
      offlinePanelsLabel: 'Hors ligne',
      sleepingPanelsLabel: 'En veille',
      pairingStatusLabel: "État de l'appairage",
      pairedPanelsLabel: 'Appairés',
      pendingPanelsLabel: 'Appairage en attente',
      lastActivityLabel: 'Dernière activité',
      noActivityLabel: 'Aucune activité récente',
      noActivityDescription: "Aucun panneau n'a encore signalé d'activité",
      attentionLabel: 'Nécessite une attention',
      justNowLabel: "à l'instant",
      minutesAgoLabel: 'il y a {count} min',
      hoursAgoLabel: 'il y a {count} h',
      daysAgoLabel: 'il y a {count} j',
      errorMessage: "Échec du chargement de l'intégration des panneaux tactiles",
    },

    integrationZigbee: {
      loadingState: 'Chargement des données Zigbee...',
      nodesTab: 'Nœuds',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      errorMessage: 'Échec de la connexion au réseau Zigbee',
    },

    integrationZWave: {
      loadingState: 'Chargement des données Z-Wave...',
      nodesTab: 'Nœuds',
      networkTab: 'Réseau',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      errorMessage: 'Échec de la connexion au réseau Z-Wave',
    },
    integrationWled: {
      segmentsTab: 'Segments',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      loadingState: 'Chargement...',
      errorMessage: "Échec du chargement de l'intégration",
    },

    integrationHue: {
      lightsTab: 'Lumières',
      groupsTab: 'Groupes',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
    },
    integrationUnifi: {
      networkTab: 'Réseau',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
    },
    integrationSomfy: {
      gatewayTab: 'Passerelle',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
    },
    integrationSynology: {
      statusTab: 'Statut',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
    },
    integrationMediaPlayers: {
      playersTab: 'Lecteurs',
      devicesTab: 'Appareils',
      sourcesTab: 'Sources',
      settingsTab: 'Paramètres',
    },
    integrationSonos: {
      settingsTab: 'Paramètres',
      playersTab: 'Lecteurs',
      devicesTab: 'Appareils',
    },
    integrationSpotify: {
      settingsTab: 'Paramètres',
      devicesTab: 'Appareils',
    },

    panelPairing: {
      title: `${brand.agentName} Panneau Tactile`,
      subtitle: "Configuration de l'appareil",
      discoverTitle: `Trouvez votre hub ${brand.agentName}`,
      discoverDescription: `Recherche de votre réseau local pour un hub ${brand.agentName}...`,
      scanningStatus: 'Analyse du réseau...',
      noHubsFound: 'Aucun hub trouvé automatiquement.',
      manualEntryHint: "Saisissez manuellement l'adresse du hub ci-dessous.",
      manualEntryLabel: 'Ou saisissez manuellement',
      ipAddressPlaceholder: 'Adresse IP du hub',
      portPlaceholder: 'Port',
      connectButton: 'Connecter',
      rescanButton: '↻ Scanner à nouveau',
      backButton: 'Retour',
      connectedToLabel: 'Connecté à',
      pairingMethodTitle: 'Appairer cet appareil',
      pairingRequirement: `Un administrateur doit générer un code d'appairage dans l'application ${brand.agentName}.`,
      enterPinButton: 'Entrer le code PIN',
      pinEntryTitle: "Entrer le code PIN d'appairage",
      pinEntryDescription: `Entrez le code PIN à 6 chiffres affiché dans l'application d'administration ${brand.agentName}.`,
      pairDeviceButton: "Appairer l'appareil",
      pairingInProgress: 'Appairage...',
      invalidPinError: 'Code PIN invalide. Veuillez réessayer.',
      cameraAccessDenied: 'Accès à la caméra refusé. Veuillez activer les autorisations de la caméra.',
      invalidQrError: 'Code QR invalide. Veuillez réessayer.',
      exitPinTitle: 'Définir le code PIN de sortie',
      exitPinDescription: 'Choisissez un code PIN à 4 chiffres pour quitter le mode panneau plus tard.',
      skipButton: 'Ignorer',
      pairedSuccess: 'Appareil appairé !',
      connectingMessage: 'Connexion à votre panneau...',
    },

    playPairing: {
      title: `${brand.agentName} Play`,
      subtitle: "Configuration de l'appareil",
      discoverTitle: `Trouvez votre hub ${brand.agentName}`,
      discoverDescription: `Recherche de votre réseau local pour un hub ${brand.agentName}...`,
      scanningStatus: 'Analyse du réseau...',
      noHubsFound: 'Aucun hub trouvé automatiquement.',
      manualEntryHint: "Saisissez manuellement l'adresse du hub ci-dessous.",
      manualEntryLabel: 'Ou saisissez manuellement',
      ipAddressPlaceholder: 'Adresse IP du hub',
      portPlaceholder: 'Port',
      connectButton: 'Connecter',
      rescanButton: '↻ Scanner à nouveau',
      backButton: 'Retour',
      connectedToLabel: 'Connecté à',
      pairingMethodTitle: 'Appairer cet appareil',
      pairingRequirement: `Un administrateur doit générer un code d'appairage dans l'application ${brand.agentName}.`,
      enterPinOption: 'Entrer le code PIN',
      enterPinDescription: "Entrez le code à 6 chiffres affiché dans l'application d'administration",
      scanQrOption: 'Scanner le code QR',
      scanQrDescription: "Scannez le code QR affiché dans l'application d'administration",
      pinEntryTitle: "Entrer le code PIN d'appairage",
      pinEntryDescription: `Entrez le code PIN à 6 chiffres affiché dans l'application d'administration ${brand.agentName}.`,
      pairDeviceButton: "Appairer l'appareil",
      pairingInProgress: 'Appairage...',
      scanQrTitle: 'Scanner le code QR',
      scanQrInstruction: `Dirigez la caméra vers le code QR dans l'application d'administration ${brand.agentName}.`,
      scanningAutoStatus: 'Scan automatique...',
      exitPinTitle: 'Définir le code PIN de sortie',
      exitPinDescription: 'Choisissez un code PIN à 4 chiffres pour quitter le mode Play plus tard.',
      confirmPinButton: 'Confirmer le code PIN',
      reenterPinInstruction: 'Ressaisissez votre code PIN pour confirmer',
      pinMismatchError: 'Les codes PIN ne correspondent pas. Réessayez.',
      skipButton: 'Ignorer',
      pairedSuccess: 'Appareil appairé !',
      pairedDescription: `Cet appareil est maintenant lié à votre hub ${brand.agentName} en tant qu'appareil Play.`,
      startPlayModeButton: 'Démarrer le mode Play',
      invalidPinError: 'Code PIN invalide. Veuillez réessayer.',
      cameraAccessDenied: 'Accès à la caméra refusé. Veuillez activer les autorisations de la caméra.',
      invalidQrError: 'Code QR invalide. Veuillez réessayer.',
    },

    gallery: {
      pageTitle: 'Photos',
      emptyTitle: 'Aucune photo pour le moment',
      emptyDescription: 'Importez des photos et des vidéos pour commencer votre galerie cloud personnelle.',
      noAlbumTitle: 'Aucun album pour le moment',
      noAlbumDescription: 'Créez un album pour regrouper et partager vos photos.',
      noAlbumItems: 'Aucune photo dans cet album pour le moment',
      newAlbum: 'Nouvel album',
      takePhoto: 'Appareil photo',
      uploadPhotos: 'Importer',
      createAlbumTitle: 'Créer un album',
      selectPhotos: 'Sélectionner',
      uploadProgress: 'Importation',
      dropZoneText: 'Déposez les photos et vidéos ici',
      uploadStatus: 'fichier',
      uploadStatusPlural: 'fichiers',
      sharedBadge: 'Partagé',
      publicBadge: 'Public',
    },

    reminders: {
      pageTitle: 'Rappels',
      addButton: 'Nouveau rappel',
      upcomingTab: 'À venir',
      completedTab: 'Terminés',
      emptyUpcoming: 'Aucun rappel à venir.',
      emptyCompleted: 'Aucun rappel terminé.',
      createReminderTitle: 'Nouveau rappel',
      editReminderTitle: 'Modifier le rappel',
      titleLabel: 'Titre',
      titlePlaceholder: 'Faire les courses',
      notesLabel: 'Notes',
      notesPlaceholder: 'Détails supplémentaires...',
      notesOptional: '(optionnel)',
      dateTimeLabel: 'Date et heure',
      repeatLabel: 'Répétition',
      repeatNone: 'Aucune',
      repeatDaily: 'Quotidienne',
      repeatWeekly: 'Hebdomadaire',
      repeatMonthly: 'Mensuelle',
      repeatWeekdays: 'Jours de semaine (Lun–Ven)',
      cancelButton: 'Annuler',
      saveButton: 'Enregistrer',
      createButton: 'Créer un rappel',
    },

    timers: {
      pageTitle: 'Minuteries',
      addButton: 'Nouvelle minuterie',
      emptyState: 'Aucune minuterie pour le moment. Appuyez sur Nouvelle minuterie pour en créer une.',
      createTimerTitle: 'Nouvelle minuterie',
      labelLabel: 'Libellé',
      labelPlaceholder: 'Eau des pâtes',
      durationLabel: 'Durée',
      hoursLabel: 'Heures',
      minutesLabel: 'Minutes',
      secondsLabel: 'Secondes',
      soundLabel: 'Son',
      totalLabel: 'total',
      startButton: 'Démarrer',
      pauseButton: 'Pause',
      resetButton: 'Réinitialiser',
      deleteButton: 'Supprimer',
      deleteConfirm: 'Supprimer cette minuterie ?',
      cancelButton: 'Annuler',
      createButton: 'Créer',
      creatingLabel: 'Création...',
      statusIdle: 'inactif',
      statusRunning: 'en cours',
      statusPaused: 'en pause',
      statusCompleted: 'terminé',
    },
    integrationESPHome: {
      entitiesTab: 'Nœuds et entités',
      devicesTab: 'Appareils',
      settingsTab: 'Paramètres',
      logsTab: 'Journaux',
      loadingState: 'Chargement des données ESPHome...',
      errorMessage: "Échec du chargement de l'intégration ESPHome",
    },
    integrationTorik: {
      entitiesTab: 'Importer',
      devicesTab: 'Appareils',
      settingsTab: 'Liaison',
      logsTab: 'Journaux',
      loadingState: 'Chargement de la liaison du hub Torik...',
      entitiesTitle: 'Appareils distants',
      entitiesHint:
        'Découvrez les appareils sur le hub lié et importez-les comme appareils locaux. Les valeurs restent synchronisées et les commandes sont transmises.',
      discover: 'Découvrir les appareils',
      discovering: 'Découverte...',
      searchPlaceholder: "Rechercher par nom ou ID d'entité...",
      selectAll: 'Tout sélectionner',
      selected: 'sélectionnés',
      importCount: 'Importer',
      imported: 'Importés',
      emptyState: 'Appuyez sur Découvrir les appareils pour récupérer les appareils du hub lié.',
      importTitle: 'Importer les appareils distants',
      roomMapping: 'Associer les pièces distantes aux pièces locales :',
      remoteRoom: 'Pièce distante :',
      noRoom: '— Aucune pièce (correspondance automatique par nom) —',
      created: 'Créés',
      skipped: 'Ignorés',
      errors: 'Erreurs',
      close: 'Fermer',
      cancel: 'Annuler',
      import: 'Importer',
      importing: 'Importation...',
      linkTitle: 'Liaison du hub',
      linkHint: 'Connexion au hub Torik lié (son API Torik).',
      test: 'Tester la connexion',
      testing: 'Test en cours...',
      sync: 'Synchroniser maintenant',
      syncing: 'Synchronisation...',
      syncDone: 'Synchronisation terminée',
      reconnect: 'Reconnecter',
      reconnecting: 'Reconnexion...',
      reconnectDone: 'Reconnecté',
      cleanup: 'Supprimer tous les appareils importés',
      cleaning: 'Suppression...',
      cleanupConfirm: 'Supprimer tous les appareils importés de ce hub ? Cette action est irréversible.',
      cleanupDone: 'Appareils supprimés',
      peerUrl: 'URL du pair',
      peerVersion: 'Version du pair',
      token: "Jeton d'accès",
    },
    // The guest experience of the demo house (card `t_803e86a4`) — see `en.ts`.
    demoGuest: {
      pill: 'Invité',
      pillNamed: 'Invité · {name}',
      hint: 'Ceci est une maison de démonstration — une journée entière est simulée en quelques minutes.',
      dismiss: 'Masquer',
    },
  },
  shell: {
    home: 'Accueil',
    // The floor for a tab nothing else names (card t_99f5ed79) — see `en.ts`.
    newTab: 'Nouvel onglet',
    closeTab: "Fermer l'onglet",
    alertError: 'Erreur',
    alertWarning: 'Avertissement',
    alertNotice: 'Alerte',
    player: 'Lecteur',
    previous: 'Précédent',
    play: 'Lecture',
    pause: 'Pause',
    mute: 'Muet',
    unmute: 'Activer le son',
    volume: 'Volume',
    // The main process's native popups (card t_99f5ed79): the tab context menu,
    // the app menu, and the connection-info dialog — see `en.ts` for the note.
    openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
    connectionInfo: 'Infos de connexion',
    reload: 'Recharger',
    fullscreen: 'Plein écran',
    close: 'Fermer',
    launcher: 'Lanceur',
    services: 'Services',
    miniPlayerWindow: 'Fenêtre du mini-lecteur',
    rebuildBar: 'Reconstruire la barre système',
    settings: 'Paramètres',
    quit: 'Quitter',
    info: {
      target: 'Cible',
      endpoint: 'Point de terminaison',
      hubId: 'ID du hub',
      hubName: 'Nom du hub',
      state: 'État',
      route: 'Route',
      connected: 'connecté',
      disconnected: 'déconnecté',
      secure: 'sécurisé',
      cloudHub: 'hub cloud {id}',
      managedInLauncher: 'Les identifiants et les serveurs enregistrés se gèrent dans le lanceur.',
      ok: 'OK',
      tab: 'Onglet',
    },
  },
  connectionLost: {
    title: 'Connexion perdue',
    session: '{hub} : votre session a expiré. Reconnectez-vous pour continuer à travailler dans cet onglet.',
    offline: '{hub} ne répond pas. Vérifiez le réseau, puis reconnectez-vous.',
    thisServer: 'Ce serveur',
    reconnect: 'Reconnecter',
    reconnecting: 'Reconnexion...',
    close: 'Fermer',
  },
  api: {
    // What a failed hub call actually means (`utils/apiFailure.ts`), so a surface
    // that only catches the error can still name the cause instead of one sentence
    // that fits every failure — read as `t(apiFailureSentenceKey(error))`.
    failure: {
      unreachable: 'Le hub est injoignable, ces réglages n’ont donc pas pu être lus.',
      refused: 'Cette fenêtre n’est pas connectée au hub, il a donc refusé ces réglages.',
      wrong_target: 'La réponse ne venait pas du service de ce hub, ces réglages n’ont donc pas pu être lus.',
      hub_failed: 'Le hub a signalé une erreur en lisant ces réglages.',
    },
  },
  hub: {
    // Adopting an unclaimed hub from the app (HEADLESS-HUB-ONBOARDING.md
    // D3/D4/D5): the confirm sheet, the sticker QR and every refusal the hub
    // can answer with — one sentence each, in every shipped locale.
    adopt: {
      title: 'Adopter ce hub',
      intro:
        'Ce hub se trouve sur votre réseau et n’a pas encore de propriétaire. En l’adoptant, il est enregistré sous votre compte Torik et vous en devenez le propriétaire.',
      notOffered:
        'Ce hub n’attend pas d’adoption : il n’y a donc rien à adopter ici. Rien n’a été envoyé — si votre compte Torik se trouve sur ce hub, ouvrez-le depuis vos serveurs.',
      hubLabel: 'Hub',
      accountLabel: 'Compte',
      roleLabel: 'Votre rôle',
      roleOwner: 'Propriétaire',
      noCode: 'Rien à saisir — votre compte est l’identifiant.',
      noAccount: 'Non connecté',
      // Une session dont cette feuille ne connaît pas le compte : l’appareil EST
      // connecté, et la ligne ne peut pas prétendre le contraire (carte t_a53c5f61).
      accountSignedIn: 'Connecté',
      signInRequired: 'Connectez-vous à votre compte Torik pour adopter ce hub.',
      signIn: 'Se connecter',
      signingIn: 'Ouverture…',
      signInFailed: 'La connexion n’a pas pu être lancée. Réessayez.',
      confirm: 'Adopter ce hub',
      working: 'Adoption…',
      retry: 'Réessayer',
      cancel: 'Annuler',
      doneTitle: '{hub} est à vous',
      doneBody: 'Il est enregistré sous {account}, et cet appareil y est désormais associé.',
      // La variante de la phrase ci-dessus sans nom de compte : `{account}` ne peut
      // pas porter une tournure dans toutes les langues, donc ce cas se reformule.
      doneBodySignedIn: 'Il est enregistré sous votre compte Torik, et cet appareil y est désormais associé.',
      doneWhere: 'Vous le trouverez dans vos serveurs, sur la page d’accueil.',
      roleLine: 'Vous avez le rôle {role} sur ce hub.',
      continue: 'Continuer',
      scanLead: 'Hub tout neuf ? Scannez le code imprimé sur sa boîte : cela l’adopte sous votre compte.',
      linkWrongHub: 'Ce code appartient à un autre hub que celui qui répond à cette adresse. Rien n’a été adopté.',
      linkUnverified:
        'Le hub à cette adresse n’a pas confirmé son identité, donc rien n’a été adopté. Vérifiez que le hub est allumé et joignable.',
      rateLimited: 'Trop de tentatives depuis cet appareil. Attendez une minute, puis réessayez.',
      notOnHubNetwork:
        'Le hub a refusé : cet appareil n’est pas sur le réseau du hub. Connectez-vous au même réseau que le hub (pas via un VPN), puis réessayez.',
      alreadyClaimed: 'Ce hub a déjà un propriétaire. Demandez-lui de vous inviter.',
      invalidCloudToken: 'La session de votre compte Torik a été refusée. Reconnectez-vous, puis adoptez.',
      invalidDevice: 'Le hub a refusé la clé de cet appareil. Réessayez.',
      cloudUnreachable:
        'Le hub n’a pas pu joindre le cloud Torik et n’a donc pas pu s’enregistrer. Vérifiez la connexion internet du hub, puis réessayez.',
      hubIdentityUnavailable: 'Le hub ne peut pas encore lire sa propre identité. Attendez un instant, puis réessayez.',
      registrationFailed:
        'Le cloud a refusé d’enregistrer le hub sous votre compte. Réessayez ou contactez le support.',
      unsupported: 'Ce hub ne prend pas en charge l’adoption (logiciel plus ancien).',
      unreachable: 'Personne n’a répondu à cette adresse. Vérifiez que le hub est allumé et sur ce réseau.',
      unproven:
        'L’appareil à cette adresse n’a pas pu prouver qu’il est bien ce hub. Rien n’a été adopté et votre compte ne lui a pas été envoyé.',
      malformed: 'Le hub a répondu sans adoption. Rien n’a été modifié.',
      refused: 'Le hub a refusé l’adoption.',
      cardAction: 'Hub sans propriétaire — l’adopter ?',
      cardHint:
        '{hub} n’appartient encore à personne. L’adopter l’enregistre sous votre compte Torik et vous en devenez propriétaire.',
      cardSignIn: 'Connectez-vous à votre compte Torik pour adopter {hub}.',
      badgeWaiting: 'En attente d’adoption',
      localPageHint: '{hub} n’a pas encore de propriétaire — trouvez-le via la recherche de serveurs locaux.',
      localPageAction: 'Rechercher les serveurs locaux',
      addressLabel: 'Adresse',
      loopbackOnly:
        'Cet appareil ne peut atteindre ce hub qu’à {address} — sa propre machine. Un hub n’accepte jamais une adoption venant de lui-même (c’est aussi de là qu’arrivent les appels tunnelisés) : adoptez-le depuis un autre appareil du même réseau.',
      tokenRetired:
        'Le hub n’accepte plus la connexion d’un compte pour l’adoption — une licence est requise. Mettez l’application à jour, puis réessayez.',
      licenceUsed:
        'Cette licence d’adoption a déjà été utilisée. Rien n’a été modifié — réessayez pour en obtenir une nouvelle.',
      licenceExpired: 'La licence d’adoption a expiré avant que le hub puisse l’utiliser. Réessayez.',
      licenceMismatch: 'Cette licence a été émise pour un autre hub. Rien n’a été adopté.',
      licenceInvalid:
        'Le hub n’a pas pu vérifier la licence signée par le cloud. Mettez à jour l’application et le hub, puis réessayez.',
      licenceRequired:
        'Le hub attendait une licence d’adoption et aucune n’a été envoyée. Mettez l’application à jour, puis réessayez.',
      licenceRefused: 'Le cloud a refusé d’émettre une licence d’adoption pour ce hub.',
      licenceUnknownHub:
        'Le cloud n’a pas pu identifier ce hub et n’a donc émis aucune licence. Laissez le hub atteindre internet une fois, puis réessayez.',
      licenceAlreadyOwned: 'Un autre compte Torik possède déjà ce hub. Demandez à son propriétaire de vous inviter.',
      licenceUnavailable:
        'Le cloud ne peut pas émettre de licence d’adoption pour le moment. Réessayez plus tard ou contactez le support.',
      licenceUnauthorized: 'Votre session de compte Torik a été refusée. Reconnectez-vous, puis adoptez.',
      licenceUnreachable:
        'Le cloud Torik était injoignable, aucune licence n’a donc pu être émise. Vérifiez la connexion internet de cet appareil et réessayez.',
      licenceMalformed: 'Le cloud a répondu sans licence. Rien n’a été adopté — réessayez.',
      password: {
        title: 'Définir un mot de passe local',
        intro:
          'Un mot de passe pour {hub} permet à cette maison de fonctionner sans internet — et à chacun de s’y connecter même si le cloud Torik est injoignable.',
        label: 'Mot de passe',
        hint: 'Au moins 8 caractères.',
        confirmLabel: 'Confirmer le mot de passe',
        mismatch: 'Les deux mots de passe ne correspondent pas.',
        currentLabel: 'Mot de passe actuel',
        save: 'Enregistrer le mot de passe',
        saving: 'Enregistrement…',
        skip: 'Pas maintenant',
        done: 'Mot de passe local enregistré — cette maison fonctionne désormais sans internet.',
        noSessionNote:
          'Cet appareil n’est pas connecté au hub, aucun mot de passe local n’a donc pu être défini. Ouvrez le hub et définissez-le là-bas.',
        resolving: 'Vérification de ce serveur…',
        noAddress:
          'Ce serveur n’a pas d’adresse que cet appareil puisse appeler : aucun mot de passe local ne peut être défini d’ici.',
        noAccount: 'Connectez-vous à votre compte Torik pour définir un mot de passe local sur ce hub.',
        notThisAccount:
          'Ce hub appartient à un autre compte Torik, ce compte ne peut donc pas définir son mot de passe local.',
        noAnswer:
          'Personne n’a répondu à l’adresse de ce hub : aucun mot de passe local n’a pu être défini. Vérifiez que le hub est allumé et sur ce réseau.',
        close: 'Fermer',
        required: 'Saisissez un mot de passe.',
        tooShort: 'Le mot de passe est trop court — au moins 8 caractères.',
        tooLong: 'Le mot de passe est trop long (72 octets au maximum).',
        wrongCurrent: 'Ce n’est pas le mot de passe que ce compte a déjà sur le hub.',
        notPermitted: 'Seul un administrateur peut définir ce mot de passe.',
        noSuchUser: 'Le hub ne connaît pas ce compte.',
        noSession: 'Cet appareil n’est pas connecté au hub, il ne peut donc pas définir de mot de passe.',
        invalidCredentials: 'Identifiant ou mot de passe incorrect.',
        disabled: 'Ce compte est désactivé sur ce hub.',
        outsideWindow:
          'Ce compte ne peut se connecter que pendant les horaires définis sur le hub. Demandez au propriétaire du hub de déplacer la plage.',
        tooManyAttempts: 'Trop de tentatives. Attendez une minute, puis réessayez.',
        unreachable: 'Personne n’a répondu à cette adresse. Vérifiez que le hub est allumé et sur ce réseau.',
        refused: 'Le hub a refusé de définir ce mot de passe.',
      },
    },
    join: {
      title: 'Rejoindre ce hub',
      intro:
        'Ce hub est sur votre réseau et votre compte Torik y détient déjà un rôle. En le rejoignant, votre compte y est relié et cet appareil peut utiliser le hub — sans code ni mot de passe.',
      hubLabel: 'Hub',
      accountLabel: 'Compte',
      roleLabel: 'Votre rôle',
      roleReading: 'Vérification…',
      roleUnknown: 'Pas encore connu',
      noCode:
        'Rien à saisir — votre compte est l’accréditation. Le code affiché sur le hub est destiné aux invités, aux intervenants et aux écrans sans clavier.',
      noAccount: 'Non connecté',
      signInRequired: 'Connectez-vous à votre compte Torik pour rejoindre ce hub.',
      confirm: 'Rejoindre ce hub',
      working: 'Connexion…',
      retry: 'Réessayer',
      cancel: 'Annuler',
      doneTitle: 'Vous avez rejoint {hub}',
      doneBody: '{account} est maintenant relié à ce hub et cet appareil peut l’utiliser.',
      roleLine: 'Votre rôle sur ce hub est {role}.',
      continue: 'Continuer',
      noMatchingUser:
        'Ce hub n’a pas encore d’utilisateur avec votre adresse e-mail. Demandez au propriétaire du hub d’inviter cette adresse, puis réessayez.',
      notAMember:
        'Votre compte Torik n’a aucun rôle sur ce hub. Demandez au propriétaire du hub d’inviter cette adresse.',
      userDisabled: 'Ce compte est désactivé sur ce hub. Demandez au propriétaire du hub de l’activer.',
      outsideLoginWindow:
        'Ce compte ne peut se connecter que pendant les horaires définis sur le hub. Demandez au propriétaire du hub de déplacer la plage.',
      invalidCloudToken: 'La session de votre compte Torik a été refusée. Reconnectez-vous, puis réessayez.',
      deviceInUse:
        'Cet appareil est déjà enregistré sous un autre compte. Révoquez-le d’abord là-bas ou utilisez un autre appareil.',
      alreadyClaimed: 'Ce hub vient de prendre cet appareil — la demande avait déjà été utilisée. Rouvrez le hub.',
      expired: 'La demande a expiré avant que le hub ne la prenne. Réessayez.',
      grantKeyMissing:
        'Le cloud Torik ne peut pas signer l’autorisation de cet appareil pour le moment. Réessayez dans un instant.',
      unknownDevice: 'Le hub ne connaît pas cet enregistrement. Réessayez.',
      notApproved: 'Le hub n’a pas encore enregistré l’autorisation de cet appareil. Réessayez dans un instant.',
      invalidProof: 'Le hub a refusé la clé de cet appareil. Réessayez.',
      rateLimited: 'Trop de tentatives depuis cet appareil. Attendez une minute et réessayez.',
      unreachable: 'Rien n’a répondu à cette adresse. Vérifiez que le hub est allumé et sur ce réseau.',
      malformed: 'Le hub a répondu sans lier cet appareil. Rien n’a été modifié.',
      refused: 'Le hub a refusé la demande. Rien n’a été modifié.',
    },

    // Un hub que cette app ne peut pas ouvrir (carte `t_bfe0edc9`) : la phrase qui dit de qui

    // identifiant manquant et où se trouve sa propre façon d’entrer (utils/hubOpenFallback.ts).

    open: {
      title: 'Impossible d’ouvrir {hub}',

      dismiss: 'Fermer',

      openLocalPage: 'Rechercher les serveurs locaux',

      openServers: 'Serveurs',

      needsCredential:
        'Les pages de ce hub ont besoin d’un identifiant que cet appareil ne possède pas. Rien n’a été envoyé et rien n’a été modifié.',

      // Une phrase par façon dont un hub reste fermé (`HUB_OPEN_FAILURES`).

      failure: {
        no_credential:
          'Cet appareil n’a pas encore d’identifiant pour {hub}. Votre compte Torik l’ouvre d’ici — sans code ni mot de passe.',

        credential_refused:
          '{hub} n’a pas accepté l’identifiant de cet appareil, il a donc été abandonné. Ouvrez-le d’ici avec votre compte Torik — aucun code n’est nécessaire.',

        no_cloud_session: 'Connectez-vous à votre compte Torik pour ouvrir {hub}.',

        no_lan_address: '{hub} n’a annoncé aucune adresse que cet appareil puisse joindre.',

        no_account_identity:
          'Votre compte Torik ne connaît pas encore {hub}. Adoptez-le ici, ou demandez à son propriétaire d’inviter cette adresse.',

        unreachable: 'Personne n’a répondu à {address}. Vérifiez que {hub} est allumé et sur ce réseau.',
        permission_held:
          'Le navigateur retient cette requête : ce site n’est pas encore autorisé à accéder à votre réseau local. Autorisez l’accès au réseau local, puis réessayez — ou ouvrez {hub} via le cloud.',

        not_this_hub: 'Quelque chose a répondu à {address}, et ce n’est pas {hub}.',

        not_proven:
          '{hub} a répondu à {address} et n’a pas pu prouver qu’il détient la clé épinglée par votre compte. Rien n’a été envoyé.',

        cannot_prove: 'L’appareil à {address} n’a pas pu être interrogé pour savoir s’il s’agit de {hub}.',

        refused:
          '{hub} a refusé la demande de votre compte Torik — demandez à son propriétaire d’inviter cette adresse.',

        // Le refus propre du **cloud** (`services/cloudSessionRefusal.ts`, plan
        // FLOOR-PLAN-AND-PLAN-EDITOR.md §3.2/D3) : le serveur est local seulement.
        // Pas un échec — son état, dit une fois.
        remote_access_not_licensed:
          'Ce serveur est réglé sur accès local uniquement — vous pouvez y accéder depuis son propre réseau. L’accès à distance est inclus dans un forfait serveur payant.',
      },
    },
    // L’**installation** (plan `LOCAL-SERVER-ONBOARDING-JOURNEY.md` §3/C2–C3,
    // décisions du propriétaire §7 Q1/Q2/Q4) : ce que la page Local ouvre pour un
    // serveur qui appartient à ce compte et dont le forfait le garde sur son
    // propre réseau. D’abord l’état, puis la phrase honnête sur le forfait payant,
    // enfin le mot de passe local (`hub.adopt.password.*` — l’étape partagée avec
    // l’adoption). Rien ne se vend ici : ni tarif ni achat, le forfait est dans le
    // compte.
    onboard: {
      title: 'Configurer ce serveur',
      intro:
        'Ce serveur fonctionne sur votre propre réseau. Voici l’état de sa licence et le mot de passe qui le garde accessible sans internet.',
      licenceLabel: 'Licence',
      reading: 'Lecture…',
      remoteTitle: 'L’accès à distance exige un forfait payant',
      remoteBody:
        'L’accès à distance à ce serveur fait partie d’un forfait payant. Gérez le forfait dans votre compte Torik.',
      accountLink: 'Gérer le forfait dans votre compte',
      accountHint: 'Ouvre votre compte Torik dans le navigateur.',
      openButton: 'Configurer {hub}',
      doneTitle: '{hub} est configuré',
      doneSkipped: 'Terminé. Vous pouvez définir le mot de passe local à tout moment depuis cette page.',
      noAddress:
        'Ce serveur n’a annoncé aucune adresse joignable par cet appareil : le mot de passe local ne peut pas être défini ici. Ouvrez-le d’abord depuis vos serveurs.',
    },
  },
  // WLED integration — the two tabs read these (WLEDSegmentsTab.vue, WLEDSettingsTab.vue)
  wled: {
    tabs: {
      segmentsTitle: 'Segments',
      segmentsSubtitle:
        'Chaque segment WLED actif peut être importé comme appareil d’éclairage (effets, palettes et préréglages inclus).',
    },
    discover: 'Détecter',
    discovering: 'Détection...',
    creating: 'Création...',
    createDevices: 'Créer les appareils d’éclairage',
    loading: 'Chargement des segments...',
    emptyTitle: 'Aucun segment trouvé',
    emptyMessage:
      'Cliquez sur Détecter pour lire la disposition des segments depuis le contrôleur WLED. Les appareils sont créés par segment — un contrôleur standard à un seul ruban possède un segment qui couvre toutes les LED.',
    createHint: 'Créer un appareil d’éclairage par segment (par défaut : tous).',
    loadFailed: 'Échec du chargement des segments',
    createFailed: 'Échec de la création des appareils',
    discoveryFailed: 'Échec de la détection',
    alreadyImported:
      'Les segments déjà importés ont été ignorés. Les nouveaux éclairages apparaissent dans Pièces / Appareils.',
    colName: 'Segment',
    colType: 'Type',
    colColor: 'Couleur',
    colEffect: 'Effet',
    colPalette: 'Palette',
    colStatus: 'Statut',
    online: 'En ligne',
    offline: 'Hors ligne',
    settings: {
      title: 'Paramètres',
      subtitle: 'Paramètres de connexion du contrôleur WLED. Une intégration gère un contrôleur.',
      connected: 'Connectée',
      disconnected: 'Déconnectée',
      noUrl: 'Aucune URL de contrôleur configurée',
      enabled: 'Activé',
      disabled: 'Désactivée',
      reconnecting: 'Reconnexion...',
      reconnect: 'Reconnecter',
      boardTitle: 'Contrôleur',
      refresh: 'Actualiser',
      name: 'Nom',
      version: 'Micrologiciel',
      leds: 'LED',
      channels: 'Canaux',
      url: 'URL du contrôleur',
      scanning: 'Recherche...',
      findOnNetwork: 'Rechercher sur le réseau',
      urlHint: 'Adresse IP ou nom d’hôte du contrôleur WLED — ou utilisez Rechercher sur le réseau.',
      apiKey: 'Clé API',
      apiKeyPlaceholder: 'Facultatif',
      hide: 'Masquer',
      show: 'Afficher',
      apiKeyHint: 'Nécessaire uniquement si la sécurité WLED est activée.',
      pollInterval: 'Intervalle d’interrogation (secondes)',
      pollHint: 'Actualisation de secours utilisée lorsque le WebSocket est indisponible.',
      testing: 'Test en cours...',
      test: 'Tester la connexion',
      saved: 'Paramètres enregistrés.',
      saving: 'Enregistrement...',
      save: 'Enregistrer les paramètres',
      errorUpdate: 'Échec de la mise à jour de l’intégration',
      errorReconnect: 'Échec de la reconnexion',
      errorConnection: 'Échec de la connexion',
      errorSave: 'Échec de l’enregistrement des paramètres',
    },
  },
} as const;
